// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `        .blog_section_b {
            font-family: 'Inter', sans-serif;
            background-color: #080A10;
            color: #E2E8F0;
            padding-bottom: 120px;
            position: relative;
            overflow: hidden;
        }

        body.light_theme .blog_section_b {
            background-color: #F8FAFC;
            color: #0F172A;
        }

        /* Ambient Glow Spheres */
        .blog_glow_1 {
            position: absolute;
            top: -10%;
            left: -10%;
            width: 50vw;
            height: 50vw;
            background: radial-gradient(circle, rgba(209, 170, 103, 0.08) 0%, rgba(209, 170, 103, 0) 70%);
            pointer-events: none;
            z-index: 1;
        }

        .blog_glow_2 {
            position: absolute;
            top: 40%;
            right: -10%;
            width: 45vw;
            height: 45vw;
            background: radial-gradient(circle, rgba(123, 97, 255, 0.06) 0%, rgba(123, 97, 255, 0) 70%);
            pointer-events: none;
            z-index: 1;
        }

        .blog_glow_3 {
            position: absolute;
            bottom: -10%;
            left: 15%;
            width: 40vw;
            height: 40vw;
            background: radial-gradient(circle, rgba(209, 170, 103, 0.05) 0%, rgba(209, 170, 103, 0) 70%);
            pointer-events: none;
            z-index: 1;
        }

        body.light_theme .blog_glow_1 {
            background: radial-gradient(circle, rgba(209, 170, 103, 0.04) 0%, rgba(209, 170, 103, 0) 70%);
        }

        body.light_theme .blog_glow_2 {
            background: radial-gradient(circle, rgba(123, 97, 255, 0.03) 0%, rgba(123, 97, 255, 0) 70%);
        }

        /* Hero Container */
        .blog_section_b .hero_container {
            position: relative;
            z-index: 10;
            padding: 100px 0 80px;
        }

        .blog_section_b .tag_badge {
            display: inline-block;
            font-size: 13px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 2px;
            color: #D1AA67;
            background: rgba(209, 170, 103, 0.1);
            padding: 6px 16px;
            border-radius: 50px;
            margin-bottom: 20px;
        }

        body.light_theme .blog_section_b .tag_badge {
            color: #b08226;
            background: rgba(209, 170, 103, 0.15);
        }

        .blog_section_b .hero_title {
            font-size: 56px;
            font-weight: 700;
            max-width: 640px;
            line-height: 1.1;
            margin-bottom: 20px;
            background: linear-gradient(135deg, #FFFFFF 30%, #D1AA67 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }

        body.light_theme .blog_section_b .hero_title {
            background: linear-gradient(135deg, #0F172A 30%, #b08226 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }

        .blog_section_b .hero_desc {
            font-size: 18px;
            line-height: 1.6;
            color: #94A3B8;
            margin-bottom: 35px;
            max-width: 600px;
        }

        body.light_theme .blog_section_b .hero_desc {
            color: #475569;
        }

        @keyframes float3D {
            0% {
                transform: translateY(0px) rotate(0deg);
            }

            50% {
                transform: translateY(-12px) rotate(1deg);
            }

            100% {
                transform: translateY(0px) rotate(0deg);
            }
        }

        .blog_section_b .top_right_img img {
            animation: float3D 6s ease-in-out infinite;
            filter: drop-shadow(0 15px 30px rgba(0, 0, 0, 0.15));
            transition: transform 0.5s cubic-bezier(0.25, 1, 0.5, 1), filter 0.5s ease;
            max-width: 100%;
            width: 100%;
        }

        .top_right_img.blogbnr_img {
            max-width: 550px;
        }

        .blog_section_b .top_right_img img:hover {
            transform: scale(1.06) rotate(3deg) translateY(-5px);
            filter: drop-shadow(0 25px 45px rgba(209, 170, 103, 0.35));
        }

        /* Dynamic Category Tab dock */
        .blog_section_b .tab_dock_wrapper {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 60px;
            margin-bottom: 40px;
            position: relative;
            z-index: 10;
            gap: 20px;
            flex-wrap: wrap;
        }

        .blog_section_b .category_dock_container {
            position: relative;
            max-width: 100%;
            display: flex;
            align-items: center;
        }

        .blog_section_b .category_dock {
            background: rgba(30, 32, 38, 0.6);
            border: 1px solid rgba(255, 255, 255, 0.05);
            -webkit-backdrop-filter: blur(5px);
                    backdrop-filter: blur(5px);
            border-radius: 50px;
            padding: 6px;
            display: flex;
            gap: 4px;
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
            overflow-x: auto;
            white-space: nowrap;
            scrollbar-width: none;
            -ms-overflow-style: none;
        }

        .blog_section_b .category_dock::-webkit-scrollbar {
            display: none;
        }

        .dock_scroll_btn {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            background: #fff;
            border: none;
            color: #111;
            width: 28px;
            height: 28px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            z-index: 20;
            box-shadow: 0 4px 10px rgb(0 0 0 / 10%);
            font-size: 12px;
            padding: 0;
            line-height: 1;
        }

        .dock_scroll_btn:hover {
            opacity: 0.9;
        }

        .dock_scroll_btn.left {
            left: -10px;
        }

        .dock_scroll_btn.right {
            right: -10px;
        }

        body.light_theme .blog_section_b .category_dock {
            background: rgb(255 255 255 / 20%);
            border: 1px solid rgba(0, 0, 0, 0.05);
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.03);
        }

        .blog_section_b .category_dock_item {
            cursor: pointer;
            padding: 10px 24px;
            font-size: 14px;
            font-weight: 600;
            color: #94A3B8;
            border-radius: 50px;
            transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
        }

        body.light_theme .blog_section_b .category_dock_item {
            color: #475569;
        }

        .blog_section_b .category_dock_item:hover {
            color: #FFFFFF;
            background: rgba(255, 255, 255, 0.03);
        }

        body.light_theme .blog_section_b .category_dock_item:hover {
            color: #0F172A;
            background: rgba(0, 0, 0, 0.02);
        }

        .blog_section_b .category_dock_item.active {
            background: #d1aa67 !important;
            color: #ffffff !important;
            font-weight: 600;
            box-shadow: 0 4px 15px rgba(209, 170, 103, 0.3);
        }

        /* Live Search Bar */
        .blog_section_b .search_input_wrap {
            position: relative;
            min-width: 280px;
        }

        .blog_section_b .search_input_wrap input {
            background: rgba(30, 32, 38, 0.6);
            border: 1px solid rgba(255, 255, 255, 0.05);
            border-radius: 50px;
            padding: 12px 24px 12px 48px;
            color: #ffffff;
            font-size: 14px;
            width: 100%;
            outline: none;
            transition: all 0.3s;
            -webkit-backdrop-filter: blur(5px);
                    backdrop-filter: blur(5px);
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
        }

        body.light_theme .blog_section_b .search_input_wrap input {
            background: rgb(255 255 255 / 20%);
            border: 1px solid rgba(0, 0, 0, 0.05);
            color: #0F172A;
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.02);
        }

        .blog_section_b .search_input_wrap input:focus {
            border-color: #D1AA67;
            box-shadow: 0 0 15px rgba(209, 170, 103, 0.2);
        }

        body.light_theme .blog_section_b .search_input_wrap input:focus {
            border-color: #b08226;
        }

        /* Massive Featured Card (Split Layout) */
        .blog_section_b .featured_card {
            background: linear-gradient(135deg, rgba(30, 32, 38, 0.5) 0%, rgba(18, 20, 24, 0.8) 100%);
            border: 1px solid rgba(255, 255, 255, 0.06);
            border-radius: 30px;
            padding: 40px;
            margin-bottom: 60px;
            position: relative;
            z-index: 10;
            box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
            -webkit-backdrop-filter: blur(5px);
                    backdrop-filter: blur(5px);
            transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
            cursor: pointer;
        }

        body.light_theme .blog_section_b .featured_card {
            background: #ffffff;
            border: 1px solid rgba(0, 0, 0, 0.05);
            box-shadow: 0 20px 50px rgba(0, 0, 0, 0.04);
        }

        .blog_section_b .featured_card:hover {
            transform: translateY(-6px);
            border-color: rgba(209, 170, 103, 0.3);
            box-shadow: 0 30px 60px rgba(209, 170, 103, 0.15);
        }

        body.light_theme .blog_section_b .featured_card:hover {
            box-shadow: 0 30px 60px rgba(0, 0, 0, 0.08);
            border-color: rgba(209, 170, 103, 0.4);
        }

        .blog_section_b .featured_split {
            display: flex;
            align-items: center;
            gap: 48px;
        }

        .blog_section_b .featured_img_wrapper {
            flex: 1.1 1;
            border-radius: 20px;
            overflow: hidden;
            position: relative;
            height: 340px;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
        }

        .blog_section_b .featured_img_wrapper img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
        }

        .blog_section_b .featured_card:hover .featured_img_wrapper img {
            transform: scale(1.04);
        }

        .blog_section_b .featured_content_wrapper {
            flex: 0.9 1;
        }

        .blog_section_b .featured_meta {
            display: flex;
            gap: 16px;
            align-items: center;
            margin-bottom: 16px;
            padding: 0;
            list-style: none;
        }

        .blog_section_b .featured_meta li {
            font-size: 13px;
            color: #64748B;
            font-weight: 500;
        }

        .blog_section_b .featured_meta li.featured_cat {
            color: #D1AA67;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 1px;
        }

        body.light_theme .blog_section_b .featured_meta li.featured_cat {
            color: #b08226;
        }

        .blog_section_b .featured_title {
            font-size: 36px;
            font-weight: 700;
            line-height: 1.25;
            color: #ffffff;
            margin-bottom: 18px;
            transition: color 0.3s;
        }

        body.light_theme .blog_section_b .featured_title {
            color: #0F172A;
        }

        .blog_section_b .featured_card:hover .featured_title {
            color: #D1AA67;
        }

        body.light_theme .blog_section_b .featured_card:hover .featured_title {
            color: #b08226;
        }

        .blog_section_b .featured_excerpt {
            font-size: 15px;
            line-height: 1.6;
            color: #94A3B8;
            margin-bottom: 30px;
        }

        body.light_theme .blog_section_b .featured_excerpt {
            color: #475569;
        }

        /* Read link */
        .blog_section_b .read_more_action {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            font-size: 15px;
            font-weight: 700;
            color: #D1AA67;
            text-decoration: none;
            transition: all 0.3s;
        }

        body.light_theme .blog_section_b .read_more_action {
            color: #D1AA67;
        }

        .blog_section_b .read_more_action:hover {
            letter-spacing: 0.5px;
        }

        /* Grid Section Title */
        .blog_section_b .grid_section_header {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            margin-bottom: 35px;
            border-bottom: 1px solid rgba(255, 255, 255, 0.05);
            padding-bottom: 16px;
        }

        body.light_theme .blog_section_b .grid_section_header {
            border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        }

        .blog_section_b .grid_section_title {
            font-size: 28px;
            font-weight: 700;
            color: #ffffff;
            margin: 0;
        }

        body.light_theme .blog_section_b .grid_section_title {
            color: #0F172A;
        }

        /* Modern CSS Grid for Cards */
        .blog_section_b .blog_cards_grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
            gap: 32px;
            position: relative;
            z-index: 10;
        }

        /* Glassmorphic Blog Cards */
        .blog_section_b .modern_blog_card {
            background: linear-gradient(180deg, rgba(30, 32, 38, 0.45) 0%, rgba(18, 20, 24, 0.8) 100%);
            border: 1px solid rgba(255, 255, 255, 0.05);
            border-radius: 24px;
            padding: 24px;
            transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
            -webkit-backdrop-filter: blur(5px);
                    backdrop-filter: blur(5px);
            display: flex;
            flex-direction: column;
            height: 100%;
            cursor: pointer;
        }

        body.light_theme .blog_section_b .modern_blog_card {
            background: #ffffff;
            border: 1px solid rgba(0, 0, 0, 0.05);
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
        }

        .blog_section_b .modern_blog_card:hover {
            transform: translateY(-8px);
            border-color: rgba(209, 170, 103, 0.35);
            box-shadow: 0 20px 40px rgba(209, 170, 103, 0.2);
        }

        body.light_theme .blog_section_b .modern_blog_card:hover {
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.07);
            border-color: rgba(209, 170, 103, 0.4);
        }

        .blog_section_b .card_img_box {
            border-radius: 16px;
            overflow: hidden;
            position: relative;
            height: 200px;
            margin-bottom: 24px;
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
        }

        .blog_section_b .card_img_box img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
        }

        .blog_section_b .modern_blog_card:hover .card_img_box img {
            transform: scale(1.06);
        }

        .blog_section_b .card_meta_row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 12px;
        }

        .blog_section_b .card_cat_tag {
            font-size: 11px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 1px;
            color: #D1AA67;
            background: rgba(209, 170, 103, 0.08);
            padding: 4px 12px;
            border-radius: 30px;
        }

        body.light_theme .blog_section_b .card_cat_tag {
            color: #D1AA67;
            background: rgba(209, 170, 103, 0.12);
        }

        .blog_section_b .card_read_time {
            font-size: 12px;
            color: #64748B;
        }

        .blog_section_b .card_title {
            font-size: 20px;
            text-align: left;
            font-weight: 700;
            line-height: 1.35;
            color: #ffffff;
            margin-bottom: 12px;
            transition: color 0.3s;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            height: 54px;
        }

        body.light_theme .blog_section_b .card_title {
            color: #0F172A;
        }

        .blog_section_b .modern_blog_card:hover .card_title {
            color: #D1AA67;
        }

        body.light_theme .blog_section_b .modern_blog_card:hover .card_title {
            color: #b08226;
        }

        .blog_section_b .card_desc {
            font-size: 14px;
            line-height: 1.5;
            color: #94A3B8;
            margin-bottom: 24px;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            height: 63px;
        }

        body.light_theme .blog_section_b .card_desc {
            color: #475569;
        }

        .blog_section_b .card_footer_action {
            margin-top: auto;
            padding-top: 16px;
            border-top: 1px solid rgba(255, 255, 255, 0.05);
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        body.light_theme .blog_section_b .card_footer_action {
            border-top: 1px solid rgba(0, 0, 0, 0.05);
        }

        /* Start Button styles */
        .blog_section_b .startbtn {
            background: #D1AA67;
            color: #ffffff;
            font-weight: 600;
            border-radius: 50px;
            padding: 12px 36px;
            box-shadow: 0 4px 15px rgba(209, 170, 103, 0.35);
            transition: all 0.3s ease;
            display: inline-block;
            text-decoration: none;
            border: none;
        }

        .blog_section_b .startbtn:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 24px rgba(209, 170, 103, 0.5);
        }

        /* CTA Card styling */
        .blog_section_b .crypto_cta {
            border-radius: 24px;
            border: 1px solid rgba(255, 255, 255, 0.06);
            background: linear-gradient(135deg, rgba(30, 32, 38, 0.85) 0%, rgba(20, 22, 26, 0.95) 100%);
            padding: 48px;
            box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
            margin-bottom: 40px;
        }

        body.light_theme .blog_section_b .crypto_cta {
            border: 1px solid rgba(209, 170, 103, 0.15);
            background: linear-gradient(135deg, #ffffff 0%, #f4f6f9 100%);
            box-shadow: 0 12px 40px rgba(0, 0, 0, 0.04);
        }

        .blog_section_b .crypto_cta h3 {
            font-size: 30px;
            font-weight: 700;
            line-height: 1.35;
            color: #ffffff;
            margin-bottom: 20px;
        }

        body.light_theme .blog_section_b .crypto_cta h3 {
            color: #1e2329;
        }

        /* Subscribe Section */
        .blog_section_b .subscribe_form {
            margin-top: 60px;
            border-radius: 24px;
            border: 1px solid rgba(255, 255, 255, 0.08);
            background: linear-gradient(135deg, rgba(209, 170, 103, 0.08) 0%, rgba(12, 14, 18, 0.95) 100%);
            padding: 40px 60px;
            position: relative;
            box-shadow: 0 15px 45px rgba(0, 0, 0, 0.3);
            overflow: hidden;
        }

        body.light_theme .blog_section_b .subscribe_form {
            border: 1px solid rgba(209, 170, 103, 0.15);
            background: linear-gradient(135deg, rgba(209, 170, 103, 0.05) 0%, #ffffff 100%);
            box-shadow: 0 15px 45px rgba(0, 0, 0, 0.04);
        }

        .blog_section_b .subscribe-input {
            background: none !important;
            border: none !important;
            color: #ffffff !important;
        }

        .blog_section_b .subscribe-input:focus {
            border-color: #d1aa6700 !important;
            box-shadow: none;
        }

        body.light_theme .blog_section_b .subscribe-input {
            background: #ffffff !important;
            color: #1e2329 !important;
        }

        body.light_theme .blog_section_b .subscribe-input:focus {
            box-shadow: none;
        }

        /* Help Callout card at the bottom */
        .blog_section_b .help_callout_box {
            margin-top: 80px;
            border-radius: 28px;
            background: linear-gradient(135deg, rgba(123, 97, 255, 0.08) 0%, rgba(209, 170, 103, 0.08) 100%);
            border: 1px solid rgba(255, 255, 255, 0.05);
            padding: 50px 60px;
            position: relative;
            z-index: 10;
            box-shadow: 0 15px 45px rgba(0, 0, 0, 0.2);
            -webkit-backdrop-filter: blur(5px);
                    backdrop-filter: blur(5px);
        }

        body.light_theme .blog_section_b .help_callout_box {
            background: linear-gradient(135deg, rgba(123, 97, 255, 0.03) 0%, rgba(209, 170, 103, 0.03) 100%);
            border: 1px solid rgba(0, 0, 0, 0.05);
            box-shadow: 0 15px 45px rgba(0, 0, 0, 0.02);
        }

        .blog_section_b .help_callout_box h3 {
            font-size: 32px;
            font-weight: 700;
            color: #ffffff;
            margin-bottom: 12px;
        }

        body.light_theme .blog_section_b .help_callout_box h3 {
            color: #0F172A;
        }

        .blog_section_b .help_callout_box p {
            color: #94A3B8;
            font-size: 16px;
            max-width: 650px;
        }

        body.light_theme .blog_section_b .help_callout_box p {
            color: #475569;
        }

        .blog_section_b .help_btn {
            background: transparent;
            border: 2px solid #D1AA67;
            color: #D1AA67 !important;
            font-weight: 600;
            font-size: 14px;
            text-transform: uppercase;
            letter-spacing: 1px;
            padding: 12px 32px;
            border-radius: 50px;
            transition: all 0.3s;
            display: inline-block;
            text-decoration: none;
        }

        body.light_theme .blog_section_b .help_btn {
            border-color: #D1AA67;
            color: #D1AA67 !important;
        }

        .blog_section_b .help_btn:hover {
            background: #D1AA67;
            color: #080A10 !important;
            box-shadow: 0 5px 15px rgba(209, 170, 103, 0.3);
            transform: translateY(-2px);
        }

        body.light_theme .blog_section_b .help_btn:hover {
            background: #D1AA67;
            color: #ffffff !important;
            box-shadow: 0 5px 15px rgba(176, 130, 38, 0.3);
            transform: translateY(-2px);
        }

        .blog_detail {
            font-family: 'Inter', sans-serif;
            color: #eaecd0;
            background-color: #0b0e11;
            padding-bottom: 80px;
        }

        body.light_theme .blog_detail {
            color: #1e2329;
            background-color: #f8fafe;
        }

        .blog_detail .inner-page-banner {
            background: radial-gradient(circle at 10% 20%, rgba(24, 26, 32, 0.75) 0%, rgba(11, 14, 17, 0.95) 90%), var(--banner-bg) !important;
            background-size: cover !important;
            background-position: center !important;
            padding: 80px 0 60px !important;
            border-bottom: 1px solid rgba(255, 255, 255, 0.05);
            position: relative;
        }

        body.light_theme .blog_detail .inner-page-banner {
            background: radial-gradient(circle at 10% 20%, rgba(244, 246, 250, 0.85) 0%, rgba(255, 255, 255, 0.97) 90%) !important;
            border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        }

        .blog_detail .inner-page-banner .title {
            font-size: 42px;
            font-weight: 700;
            background: linear-gradient(135deg, #ffffff 0%, #a2a6b0 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }

        body.light_theme .blog_detail .inner-page-banner .title {
            background: linear-gradient(135deg, #1e2329 0%, #4a5568 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }

        .blog-details-wrapper .blog-content {
            border-radius: 24px;
            overflow: hidden;
            border: 1px solid rgba(255, 255, 255, 0.05);
            background: rgba(30, 32, 38, 0.45);
            padding: 48px;
            box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
            -webkit-backdrop-filter: blur(5px);
                    backdrop-filter: blur(5px);
        }

        body.light_theme .blog-details-wrapper .blog-content {
            border: 1px solid rgba(0, 0, 0, 0.05);
            background: #ffffff;
            box-shadow: 0 12px 40px rgba(0, 0, 0, 0.03);
        }

        .blog_detail .single_blog_img {
            border-radius: 16px;
            overflow: hidden;
            margin-bottom: 35px;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
        }

        .blog_detail .single_blog_img img {
            width: 100%;
            height: auto;
            object-fit: cover;
            max-height: 420px;
        }

        .blog_detail .blog-content h2 {
            font-size: 34px;
            font-weight: 700;
            color: #ffffff;
            line-height: 1.3;
            margin-bottom: 24px;
        }

        body.light_theme .blog_detail .blog-content h2 {
            color: #1e2329;
        }

        .blog_detail .blog-content p {
            font-size: 16px;
            line-height: 1.85;
            color: #cccccc;
            margin-bottom: 20px;
            text-align: justify;
        }

        body.light_theme .blog_detail .blog-content p {
            color: #474d57;
        }

        /* Sidebar styles */
        .blog_detail .sidebar .single-widget {
            border-radius: 24px;
            border: 1px solid rgba(255, 255, 255, 0.05);
            background: rgba(30, 32, 38, 0.45);
            padding: 30px 24px;
            box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
            -webkit-backdrop-filter: blur(5px);
                    backdrop-filter: blur(5px);
        }

        body.light_theme .blog_detail .sidebar .single-widget {
            border: 1px solid rgba(0, 0, 0, 0.05);
            background: #ffffff;
            box-shadow: 0 12px 40px rgba(0, 0, 0, 0.03);
        }

        .blog_detail .sidebar .single-widget h3.title {
            font-size: 20px;
            font-weight: 700;
            color: #D1AA67;
            margin-bottom: 24px;
            border-left: 4px solid #D1AA67;
            padding-left: 12px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }

        body.light_theme .blog_detail .sidebar .single-widget h3.title {
            color: #b08226;
            border-left-color: #b08226;
        }

        .blog_detail .sidebar .list_with_img li {
            cursor: pointer;
            transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
            border-bottom: 1px solid rgba(255, 255, 255, 0.05);
            padding: 15px 0;
        }

        body.light_theme .blog_detail .sidebar .list_with_img li {
            border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        }

        .blog_detail .sidebar .list_with_img li:first-child {
            padding-top: 0;
        }

        .blog_detail .sidebar .list_with_img li:last-child {
            border-bottom: none;
            padding-bottom: 0;
        }

        .blog_detail .sidebar .list_with_img li:hover {
            transform: translateX(4px);
        }

        .blog_detail .sidebar .list_with_img li a {
            color: #ffffff;
            font-weight: 600;
            line-height: 1.4;
            font-size: 14px;
            text-decoration: none;
            transition: color 0.3s;
        }

        body.light_theme .blog_detail .sidebar .list_with_img li a {
            color: #1e2329;
        }

        .blog_detail .sidebar .list_with_img li:hover a {
            color: #D1AA67;
        }

        body.light_theme .blog_detail .sidebar .list_with_img li:hover a {
            color: #b08226;
        }

        /* Back Link */
        .blog_detail .back-link {
            color: #848e9c !important;
            font-weight: 600;
            font-size: 14px;
            text-decoration: none;
            transition: all 0.3s;
            display: inline-flex;
            align-items: center;
            gap: 8px;
        }

        .blog_detail .back-link:hover {
            color: #D1AA67 !important;
        }

        body.light_theme .blog_detail .back-link:hover {
            color: #b08226 !important;
        }

        .blog_detail .back-link .arrow {
            transition: transform 0.3s;
        }

        .blog_detail .back-link:hover .arrow {
            transform: translateX(-4px);
        }

        .subscribe_form.blog_news form {
            width: 100%;
        }











        .blog-page {
            font-family: 'Inter', 'Outfit', system-ui, -apple-system, sans-serif;
            background-color: #FFFFFF;
            color: #1A1C23;
            padding: 40px 0 80px 0;
        }

        .blog-container {
            max-width: 1480px;
            margin: 0 auto;
            padding: 0 20px;
        }

        /* --- Header Section --- */
        .blog-header {
            margin-bottom: 30px;
        }

        .blog-header h1 {
            font-size: 40px;
            font-weight: 700;
            color: #111827;
            margin: 0 0 10px 0;
        }

        .blog-header p {
            font-size: 16px;
            color: #9CA3AF;
            margin: 0 0 24px 0;
        }

        .blog-categories {
            display: flex;
            margin-top: 10px;
            gap: 10px;
            flex-wrap: wrap;
        }

        .blog-cat-btn {
            padding: 8px 18px;
            border-radius: 20px;
            font-size: 14px;
            font-weight: 500;
            color: #838383;
            background-color: #F3F4F6;
            border: none;
            cursor: pointer;
            transition: all 0.2s;
        }

        .blog-cat-btn.active {
            background-color: #D1AA67;
            color: #FFFFFF;
            font-weight: 600;
        }

        /* --- Main Content Grid Layout --- */
        .blog-content-layout {
            display: flex;
            gap: 30px;
            margin-top: 10px;
        }

        .blog-main-column {
            flex: 1 1 70%;
        }

        .blog-sidebar-column {
            width: 320px;
            flex-shrink: 0;
        }

        /* --- Featured Post --- */
        .featured-post-card {
            background: #FFFFFF;
            border: 1px solid #F3F4F6;
            border-radius: 16px;
            overflow: hidden;
            margin-bottom: 70px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);
        }

        .featured-img-container {
            width: 100%;
            aspect-ratio: 16 / 9;
            overflow: hidden;
            background: #080A10;
        }

        .featured-img-container img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
        }

        .blog-empty {
            font-size: 15px;
            color: #6B7280;
            margin: 24px 0;
        }

        .blog-empty--sidebar {
            margin: 0;
            font-size: 13px;
        }

        .featured-post-body {
            padding: 20px 24px;
        }

        .post-meta {
            display: flex;
            align-items: center;
            gap: 15px;
            font-size: 14px;
            color: #9CA3AF;
            margin-bottom: 12px;
        }

        .badge-tag {
            color: #D1AA67;
            font-weight: 600;
            background: #FFFBEB;
            padding: 2px 8px;
            border-radius: 4px;
        }

        .featured-post-title {
            font-size: 20px;
            font-weight: 700;
            color: #111827;
            line-height: 1.4;
            margin-bottom: 10px;
        }

        .featured-post-excerpt {
            font-size: 14px;
            color: #6B7280;
            line-height: 1.6;
            margin: 0;
        }

        /* --- Blog Posts Grid --- */
        .posts-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 20px;
        }

        .post-card {
            background: #FFFFFF;
            border: 1px solid #F3F4F6;
            border-radius: 18px;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            box-shadow: 0 2px 10px rgb(0 0 0 / 8%);
            transition: transform 0.2s, box-shadow 0.2s;
        }

        .post-card:hover {
            transform: translateY(-3px);
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.06);
        }

        .post-card-img {
            width: 100%;
            height: 160px;
            object-fit: cover;
        }

        .post-card-body {
            padding: 16px;
            display: flex;
            flex-direction: column;
            flex: 1 1;
        }

        .post-card-title {
            font-size: 16px;
            font-weight: 700;
            color: #111827;
            line-height: 1.4;
            margin: 8px 0;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
        }

        .post-card-desc {
            font-size: 14px;
            color: #6B7280;
            line-height: 1.5;
            margin-bottom: 16px;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            flex: 1 1;
        }

        .post-card-footer {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 14px;
            color: #9CA3AF;
            border-top: 1px solid #FAFAFA;
            padding-top: 12px;
        }

        .read-more-link {
            color: #D3B06C;
            font-weight: 600;
            text-decoration: none;
            transition: all 0.2s;
        }

        .read-more-link:hover {
            color: #cca860;
        }

        /* --- Sidebar (Hot & Trending) --- */
        .sidebar-card {
            background: #FFFFFF;
            border: 1px solid #F3F4F6;
            border-radius: 16px;
            padding: 24px 20px;
            box-shadow: 0 2px 10px rgb(0 0 0 / 5%);
        }

        .sidebar-title {
            font-size: 16px;
            font-weight: 700;
            color: #111827;
            margin: 0 0 20px 0;
        }

        .trending-list {
            display: flex;
            flex-direction: column;
            gap: 18px;
        }

        .trending-item {
            display: flex;
            align-items: flex-start;
            gap: 12px;
        }

        .trending-num {
            width: 24px;
            height: 24px;
            border-radius: 50%;
            background: #D3B06C;
            color: #FFFFFF;
            font-size: 12px;
            font-weight: 700;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            margin-top: 2px;
        }

        .trending-info {
            flex: 1 1;
        }

        .trending-headline {
            font-size: 14px;
            font-weight: 600;
            color: #111827;
            line-height: 1.4;
            margin: 0 0 4px 0;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            cursor: pointer;
        }

        .trending-headline:hover {
            color: #D3B06C;
        }

        .trending-date {
            font-size: 11px;
            color: #9CA3AF;
        }

        /* --- Pagination --- */
        .blog-pagination {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 8px;
            margin-top: 40px;
        }

        .page-btn {
            width: 32px;
            height: 32px;
            border-radius: 8px;
            border: 1px solid #F3F4F6;
            background: #FFFFFF;
            color: #6B7280;
            font-size: 13px;
            font-weight: 600;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.2s;
        }

        .page-btn.active {
            background: #D3B06C;
            color: #FFFFFF;
            border-color: #D3B06C;
        }

        .page-btn:hover:not(.active):not(:disabled) {
            background: #F9FAFB;
        }

        .page-btn:disabled {
            opacity: 0.4;
            cursor: not-allowed;
        }

        @media (max-width: 1500px) {

            .blog-container {
                max-width: 95%;
            }

        }


        @media (max-width: 1200px) {

            .blog-header h1 {
                font-size: 32px;
            }

            .posts-grid {
                grid-template-columns: repeat(2, 1fr);
            }

        }


        /* --- Responsive Adjustments --- */
        @media (max-width: 992px) {

            .blog-content-layout {
                flex-direction: column;
            }

            .blog-header h1 {
                font-size: 26px;
            }

            .blog-sidebar-column {
                width: 100%;
            }

            .posts-grid {
                grid-template-columns: repeat(2, 1fr);
            }
        }

        @media (max-width: 600px) {

            .blog-header h1 {
                font-size: 24px;
            }

            .posts-grid {
                grid-template-columns: 1fr;
            }


            .blog-header p {
                font-size: 14px;
                margin: 0 0 18px 0;
            }

            .blog-cat-btn {
                padding: 6px 15px;
                font-size: 13px;
            }

            .post-meta {
                gap: 10px;
                font-size: 12px;
            }

            .featured-post-body {
                padding: 20px;
            }

            .featured-post-title {
                font-size: 18px;
            }

            .featured-post-card {
                margin-bottom: 30px;
            }


        }



















        @media (max-width:1440px) {

            .blog_section_b .hero_title {
                font-size: 48px;
            }
        }

        @media (max-width:1200px) {

            .blog_section_b .hero_title {
                font-size: 38px;
            }

            .blog_detail_page .container.blog_detail_container {
                width: 95%;
            }

            .blog_section_b .hero_desc {
                font-size: 16px;
                width: 90%;
            }

            .blog_section_b .featured_title {
                font-size: 26px;
            }

            .subscribe_form h4 {
                font-size: 26px;
            }

            .blog_section_b .help_callout_box h3 {
                font-size: 26px;
            }

            .blog_section_b .hero_container {
                padding: 60px 0 40px;
            }

            .blog_section_b .subscribe_form {
                padding: 24px 30px;
            }


        }


        /* Responsiveness */
        @media (max-width: 991px) {

            .blog-details-wrapper .blog-content {
                padding: 32px;
            }

            .blog_detail .inner-page-banner .title {
                font-size: 30px;
            }

            .blog_detail .inner-page-banner {
                padding: 40px 0 20px !important;
            }

            .subscribe_form h4 {
                font-size: 22px;
            }

            .blog_section_b .hero_title {
                font-size: 30px;
            }

            .blog_section_b .featured_split {
                flex-direction: column;
                gap: 30px;
            }

            .blog_section_b .featured_img_wrapper {
                width: 100%;
                height: 260px;
            }

            .blog_section_b .help_callout_box {
                padding: 40px;
                text-align: center;
            }

            .blog_section_b .help_callout_box p {
                margin: 10px auto 25px;
            }

            .blog_detail .blog-content h2 {
                font-size: 24px;
            }

            .single-widget.recent-post.mt-5 {
                margin-top: 24px !important;
            }

        }

        @media (max-width: 767px) {


            .blog_detail_title {
                font-size: 20px;
            }

            .blog_detail .inner-page-banner {
                padding: 20px 0 20px !important;
            }

            .blog-container {
                max-width: 100%;
            }

            .blog_detail .inner-page-banner .title {
                font-size: 22px;
            }

            .blog_section_b .hero_container {
                padding: 24px 0 20px;
                text-align: center;
            }

            ol.breadcrumb {
                font-size: 12px;
            }

            .blog-details-wrapper .blog-content {
                padding: 20px;
            }

            .blog_detail .sidebar .single-widget h3.title {
                font-size: 18px;
            }

            .blog_detail .sidebar .list_with_img li {
                margin: 0px !important;
            }

            .blog_section_b .hero_title {
                font-size: 24px;
            }

            .blog_section_b .hero_desc {
                font-size: 15px;
                width: 100%;
                margin-bottom: 20px;
            }

            .blog_section_b .tab_dock_wrapper {
                margin-top: 20px;
                margin-bottom: 20px;
            }

            .blog_section_b .category_dock_item {
                padding: 8px 12px;
                font-size: 12px;
            }

            .blog_section_b .top_right_img img {
                max-width: 310px;
            }

            .top_right_img {
                max-width: 310px;
                margin: 0 auto;
            }

            .blog_section_b .featured_card {
                padding: 24px;
                margin-bottom: 30px;
            }

            .blog_section_b .grid_section_title {
                font-size: 22px;
            }

            .blog_section_b .help_callout_box {
                padding: 24px;
                margin-top: 40px;
            }

            .blog_section_b .help_callout_box p {
                font-size: 14px;
            }

            .blog_section_b .help_btn {
                font-size: 12px;
                padding: 8px 32px;
            }

            .blog_detail .blog-content h2 {
                font-size: 20px;
            }

            .blog_detail .blog-content p {
                font-size: 14px;
            }

        }

        @media (max-width:580px) {

            .blog_section_b .search_input_wrap {
                min-width: 100%;
            }

            .blog_section_b .featured_title {
                font-size: 20px;
            }

            .blog_section_b .featured_meta {
                gap: 10px;
            }

            .blog_section_b .featured_excerpt {
                font-size: 14px;
                margin-bottom: 18px;
            }

            .blog_section_b .blog_cards_grid {
                gap: 22px;
            }

            .blog_section_b .subscribe_form {
                margin-top: 30px;
            }


            .blog_section_b .category_dock_item {
                padding: 5px 9px;
                font-size: 12px;
                white-space: nowrap;
            }

            .blog_section_b .read_more_action {
                font-size: 13px;
            }

            .blog_section_b .grid_section_title {
                font-size: 20px;
            }

            .blog_section_b .grid_section_header {
                margin-bottom: 20px;
            }

            .blog_section_b .blog_cards_grid {
                grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
            }

            .blog_section_b .modern_blog_card {
                border-radius: 20px;
                padding: 18px;
            }

            .subscribe_form h4 {
                font-size: 18px;
            }

            .blog_section_b .subscribe_form {
                padding: 20px;
            }

            .blog_section_b .subscribe-input {
                font-size: 12px !important;
                padding: 10px 16px !important;
            }

            .blog_section_b .startbtn {
                padding: 10px 22px;
            }

            .subscribe_form form {
                margin-top: 5px;
            }

            .blog_section_b .help_callout_box h3 {
                font-size: 22px;
            }

            .blog_section_b .search_input_wrap input {
                padding: 10px 22px 10px 38px;
                font-size: 12px;
            }


        }

        /* ==========================================================================
   BLOG DETAILS PAGE STYLES (Matching Screenshot input_file_0.png - Light Theme Default)
   ========================================================================== */

        .blog_detail_page {
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
            background-color: #FFFFFF;
            color: #0F172A;
            padding: 40px 0 100px;
            min-height: 100vh;
        }

        body:not(.light_theme) .blog_detail_page {
            background-color: #181a20;
            color: #E2E8F0;
        }

        .blog_detail_container {
            max-width: 1280px;
            margin: 0 auto;
            padding: 0 20px;
        }

        .blog_detail_back {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            margin: 0 0 20px;
            color: #848e9c;
            font-size: 14px;
            font-weight: 600;
            text-decoration: none;
            transition: color 0.25s ease;
        }

        .blog_detail_back:hover {
            color: #D1AA67;
        }

        body.light_theme .blog_detail_back {
            color: #64748b;
        }

        body.light_theme .blog_detail_back:hover {
            color: #b08226;
        }

        .blog_detail_back_arrow {
            display: inline-block;
            transition: transform 0.25s ease;
        }

        .blog_detail_back:hover .blog_detail_back_arrow {
            transform: translateX(-4px);
        }

        /* Category Tags */
        .blog_detail_tags {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
            margin-bottom: 16px;
        }

        .blog_tag_pill {
            display: inline-block;
            font-size: 12px;
            font-weight: 600;
            color: #E11D48;
            background: #FFF0F0;
            padding: 4px 12px;
            border-radius: 6px;
        }

        body:not(.light_theme) .blog_tag_pill {
            color: #E11D48;
            background: rgba(225, 29, 72, 0.12);
        }

        /* Main Article Title */
        .blog_detail_title {
            font-size: 30px;
            font-weight: 700;
            line-height: 1.25;
            color: #0F172A;
            margin-bottom: 16px;
            letter-spacing: -0.5px;
        }

        body:not(.light_theme) .blog_detail_title {
            color: #FFFFFF;
        }

        /* Subtitle / Excerpt */
        .blog_detail_subtitle {
            font-size: 16px;
            line-height: 1.6;
            color: #64748B;
            margin-bottom: 24px;
        }

        body:not(.light_theme) .blog_detail_subtitle {
            color: #94A3B8;
        }

        /* Hero Image */
        .blog_detail_hero_img_wrap {
            width: 100%;
            aspect-ratio: 16 / 9;
            overflow: hidden;
            margin-bottom: 24px;
            background: #080A10;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
        }

        .blog_detail_hero_img {
            width: 100%;
            height: 100%;
            aspect-ratio: 16 / 9;
            object-fit: cover;
            display: block;
            border: 5px solid rgb(246 246 246 / 30%);
        }

        body.light_theme .blog_detail_hero_img {
            border: 5px solid rgb(255 255 255 / 60%);
        }

        .blog_detail_layout .blog-prose p {
            font-size: 16px;
            color: #6B7280;
            margin-bottom: 12px !important;
        }

        .blog_detail_layout .blog-prose ul {
            list-style: disc;
        }

        .blog_detail_layout .blog-prose a {
            color: #d1aa67;
        }

        /* Author & Meta Bar */
        .blog_detail_author_meta {
            display: flex;
            align-items: center;
            gap: 12px;
            margin-bottom: 32px;
        }

        .blog_detail_author_meta .author_avatar {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            background: #F59E0B;
            color: #FFFFFF;
            font-weight: 700;
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            overflow: hidden;
        }

        .blog_detail_author_meta .author_avatar img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        .blog-prose {
            font-size: 15px;
            line-height: 1.7;
            color: #475569;
        }

        body:not(.light_theme) .blog-prose {
            color: #94A3B8;
        }

        .blog-prose h1,
        .blog-prose h2,
        .blog-prose h3,
        .blog-prose h4,
        .blog-prose h5,
        .blog-prose h6 {
            font-weight: 700;
            color: #0F172A;
            margin-top: 36px;
            margin-bottom: 16px;
            scroll-margin-top: 100px;
        }

        .blog-prose h1 {
            font-size: 28px;
        }

        .blog-prose h2 {
            font-size: 22px;
        }

        .blog-prose h3 {
            font-size: 18px;
        }

        .blog-prose h4 {
            font-size: 16px;
        }

        .blog-prose h5,
        .blog-prose h6 {
            font-size: 15px;
        }

        body:not(.light_theme) .blog-prose h1,
        body:not(.light_theme) .blog-prose h2,
        body:not(.light_theme) .blog-prose h3,
        body:not(.light_theme) .blog-prose h4,
        body:not(.light_theme) .blog-prose h5,
        body:not(.light_theme) .blog-prose h6 {
            color: #F8FAFC;
        }

        .blog-prose p {
            margin-bottom: 18px;
        }

        .blog-prose span[style*="font-size"] {
            line-height: 1.45;
        }

        .blog-prose a {
            color: #D3B06C;
            font-weight: 600;
        }

        .blog-prose i[class*="fa"] {
            font-style: normal;
        }

        .blog-prose mark {
            background: #fef08a;
            padding: 0 0.15em;
        }

        .blog-prose img {
            max-width: 100%;
            height: auto;
            border-radius: 8px;
        }

        .blog-prose h1,
        .blog-prose h2,
        .blog-prose h3,
        .blog-prose h4,
        .blog-prose h5,
        .blog-prose h6 {
            overflow: visible;
            line-height: 1.4;
            max-width: 100%;
        }

        .blog-prose div,
        .blog-prose .blog-box {
            overflow: visible;
            max-width: 100%;
            box-sizing: border-box;
        }

        .blog-prose table {
            width: 100%;
            max-width: 100%;
            border-collapse: collapse;
            margin: 0 0 18px;
        }

        .blog-prose th,
        .blog-prose td {
            border: 1px solid #E2E8F0;
            padding: 8px 10px;
            vertical-align: top;
            word-break: break-word;
        }

        .blog-prose ul,
        .blog-prose ol {
            margin: 0 0 18px 1.2em;
        }

        .blog-prose li {
            margin-bottom: 8px;
        }

        .blog_detail_author_meta .author_info {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 13px;
        }

        .blog_detail_author_meta .author_name {
            font-weight: 600;
            color: #334155;
        }

        body:not(.light_theme) .blog_detail_author_meta .author_name {
            color: #E2E8F0;
        }

        .blog_detail_author_meta .meta_dot {
            color: #94A3B8;
        }

        .blog_detail_author_meta .meta_time_date {
            color: #64748B;
        }

        body:not(.light_theme) .blog_detail_author_meta .meta_time_date {
            color: #94A3B8;
        }

        /* Security Alert Box */
        .blog_alert_box {
            background: #FFF7ED;
            border: 1px solid #FED7AA;
            border-radius: 10px;
            padding: 16px 20px;
            display: flex;
            align-items: flex-start;
            gap: 12px;
            margin-bottom: 32px;
        }

        body:not(.light_theme) .blog_alert_box {
            background: rgba(234, 88, 12, 0.12);
            border-color: rgba(234, 88, 12, 0.3);
        }

        .blog_alert_box .alert_icon {
            font-size: 18px;
            flex-shrink: 0;
        }

        .blog_alert_box .alert_content {
            font-size: 14px;
            line-height: 1.5;
            color: #C2410C;
        }

        body:not(.light_theme) .blog_alert_box .alert_content {
            color: #FDBA74;
        }

        /* Key Takeaway Box */
        .blog_takeaways_card {
            background: #F8FAFC;
            border: 1px solid #E2E8F0;
            border-radius: 12px;
            padding: 24px;
            margin-bottom: 36px;
        }

        body:not(.light_theme) .blog_takeaways_card {
            background: #ffffff08;
            border-color: rgba(255, 255, 255, 0.08);
        }

        .blog_takeaways_card .takeaways_title {
            font-size: 16px;
            font-weight: 700;
            color: #0F172A;
            margin-bottom: 16px;
        }

        body:not(.light_theme) .blog_takeaways_card .takeaways_title {
            color: #FFFFFF;
        }

        .blog_takeaways_card .takeaways_list {
            list-style: none;
            padding: 0;
            margin: 0;
            display: flex;
            flex-direction: column;
            gap: 12px;
        }

        .blog_takeaways_card .takeaways_list li {
            display: flex;
            align-items: flex-start;
            gap: 8px;
            font-size: 14px;
            line-height: 1.5;
            color: #334155;
        }

        body:not(.light_theme) .blog_takeaways_card .takeaways_list li {
            color: #CBD5E1;
        }

        .blog_takeaways_card .list_num {
            font-weight: 700;
            color: #D97706;
            flex-shrink: 0;
        }

        /* Section Block */
        .blog_section_block {
            margin-bottom: 36px;
        }

        .blog_section_block .section_heading {
            font-size: 18px;
            font-weight: 700;
            color: #0F172A;
            margin-top: 36px;
            margin-bottom: 16px;
        }

        body:not(.light_theme) .blog_section_block .section_heading {
            color: #F8FAFC;
        }

        .blog_section_block .section_p {
            font-size: 15px;
            line-height: 1.7;
            color: #475569;
            margin-bottom: 18px;
        }

        body:not(.light_theme) .blog_section_block .section_p {
            color: #94A3B8;
        }

        /* Badge Numbered List */
        .badge_numbered_list {
            list-style: none;
            padding: 0;
            margin: 20px 0;
            display: flex;
            flex-direction: column;
            gap: 14px;
        }

        .badge_numbered_list li {
            display: flex;
            align-items: flex-start;
            gap: 12px;
        }

        .badge_numbered_list .badge_circle_num {
            width: 26px;
            height: 26px;
            border-radius: 50%;
            background: #FFEDD5;
            color: #D97706;
            font-size: 13px;
            font-weight: 700;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
        }

        body:not(.light_theme) .badge_numbered_list .badge_circle_num {
            background: rgba(217, 119, 6, 0.2);
            color: #F59E0B;
        }

        .badge_numbered_list .badge_list_text {
            font-size: 14px;
            line-height: 1.6;
            color: #334155;
            margin-top: 2px;
        }

        body:not(.light_theme) .badge_numbered_list .badge_list_text {
            color: #CBD5E1;
        }

        /* Impact Stats Grid */
        .impact_stats_grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 20px;
            margin: 24px 0 36px;
        }

        .impact_stat_card {
            border-radius: 12px;
            padding: 24px;
            text-align: center;
        }

        .impact_stat_card.danger {
            background: #FEF2F2;
            border: 1px solid #FEE2E2;
        }

        body:not(.light_theme) .impact_stat_card.danger {
            background: rgba(239, 68, 68, 0.1);
            border-color: rgba(239, 68, 68, 0.2);
        }

        .impact_stat_card.danger .stat_icon {
            color: #EF4444;
        }

        .impact_stat_card.danger .stat_val {
            color: #EF4444;
        }

        .impact_stat_card.danger .stat_label {
            color: #DC2626;
        }

        body:not(.light_theme) .impact_stat_card.danger .stat_label {
            color: #F87171;
        }

        .impact_stat_card.warning {
            background: #FFF7ED;
            border: 1px solid #FFEDD5;
        }

        body:not(.light_theme) .impact_stat_card.warning {
            background: rgba(249, 115, 22, 0.1);
            border-color: rgba(249, 115, 22, 0.2);
        }

        .impact_stat_card.warning .stat_icon {
            color: #F97316;
        }

        .impact_stat_card.warning .stat_val {
            color: #F97316;
        }

        .impact_stat_card.warning .stat_label {
            color: #EA580C;
        }

        body:not(.light_theme) .impact_stat_card.warning .stat_label {
            color: #FB923C;
        }

        .impact_stat_card .stat_icon {
            font-size: 24px;
            margin-bottom: 8px;
        }

        .impact_stat_card .stat_val {
            font-size: 32px;
            font-weight: 800;
            line-height: 1.1;
            margin-bottom: 6px;
        }

        .impact_stat_card .stat_label {
            font-size: 13px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }

        /* Checkmark List */
        .checkmark_list {
            list-style: none;
            padding: 0;
            margin: 20px 0;
            display: flex;
            flex-direction: column;
            gap: 12px;
        }

        .checkmark_list li {
            display: flex;
            align-items: flex-start;
            gap: 10px;
        }

        .checkmark_list .check_icon {
            color: #10B981;
            font-size: 16px;
            font-weight: 700;
            flex-shrink: 0;
            margin-top: 2px;
        }

        .checkmark_list .check_text {
            font-size: 14px;
            line-height: 1.6;
            color: #334155;
        }

        body:not(.light_theme) .checkmark_list .check_text {
            color: #CBD5E1;
        }

        /* Open sidebar (mock: agcx-blog-sidebar-v2) */
        .blog_detail_layout {
            display: grid;
            grid-template-columns: 1fr;
            gap: 28px;
            align-items: start;
            min-width: 0;
        }

        .blog_detail_main,
        .blog_detail_sidebar {
            min-width: 0;
        }

        .blog_aside {
            border-left: none;
            padding-left: 0;
            padding-right: 6px;
            display: flex;
            flex-direction: column;
            background: #ffffff;
            scrollbar-width: thin;
            scrollbar-color: transparent transparent;
            transition: scrollbar-color 0.2s ease;
        }

        .blog_aside:hover,
        .blog_aside:focus-within {
            scrollbar-color: rgba(15, 23, 42, 0.2) transparent;
        }

        .blog_aside::-webkit-scrollbar {
            width: 5px;
            height: 5px;
        }

        .blog_aside::-webkit-scrollbar-track {
            background: transparent;
        }

        .blog_aside::-webkit-scrollbar-thumb {
            background: transparent;
            border-radius: 10px;
            -webkit-transition: background-color 0.2s ease;
            transition: background-color 0.2s ease;
        }

        .blog_aside:hover::-webkit-scrollbar-thumb,
        .blog_aside:focus-within::-webkit-scrollbar-thumb {
            background: rgba(15, 23, 42, 0.2);
        }

        .blog_aside:hover::-webkit-scrollbar-thumb:hover {
            background: rgba(15, 23, 42, 0.35);
        }

        body:not(.light_theme) .blog_aside,
        html[data-theme="dark"] .blog_aside,
        body.dark-mode .blog_aside {
            background: #181a20;
            scrollbar-color: transparent transparent;
        }

        body:not(.light_theme) .blog_aside:hover,
        body:not(.light_theme) .blog_aside:focus-within,
        html[data-theme="dark"] .blog_aside:hover,
        html[data-theme="dark"] .blog_aside:focus-within,
        body.dark-mode .blog_aside:hover,
        body.dark-mode .blog_aside:focus-within {
            scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
        }

        body:not(.light_theme) .blog_aside:hover::-webkit-scrollbar-thumb,
        body:not(.light_theme) .blog_aside:focus-within::-webkit-scrollbar-thumb,
        html[data-theme="dark"] .blog_aside:hover::-webkit-scrollbar-thumb,
        html[data-theme="dark"] .blog_aside:focus-within::-webkit-scrollbar-thumb,
        body.dark-mode .blog_aside:hover::-webkit-scrollbar-thumb,
        body.dark-mode .blog_aside:focus-within::-webkit-scrollbar-thumb {
            background: rgba(255, 255, 255, 0.2);
        }

        body:not(.light_theme) .blog_aside:hover::-webkit-scrollbar-thumb:hover,
        html[data-theme="dark"] .blog_aside:hover::-webkit-scrollbar-thumb:hover,
        body.dark-mode .blog_aside:hover::-webkit-scrollbar-thumb:hover {
            background: rgba(255, 255, 255, 0.35);
        }

        body:not(.light_theme) .blog_aside {
            border-left-color: rgba(255, 255, 255, 0.08);
        }

        .blog_aside_sec {
            padding: 22px;
            border: 1px solid #3b3b3b;
            border-radius: 18px;
        }

        body.light_theme .blog_aside_sec {
            border: 1px solid #F3F4F6;
        }

        .blog_aside_sec+.blog_aside_sec {
            border-top: 1px solid rgba(15, 23, 42, 0.1);
            padding-top: 28px;
        }

        body:not(.light_theme) .blog_aside_sec+.blog_aside_sec {
            border-top-color: rgba(255, 255, 255, 0.08);
        }

        .blog_aside_head {
            display: flex;
            align-items: baseline;
            justify-content: space-between;
            margin-bottom: 16px;
        }

        .blog_aside_head h3 {
            font-size: 15.5px;
            font-weight: 600;
            letter-spacing: 0.01em;
            margin: 0;
            display: flex;
            align-items: center;
            gap: 9px;
            color: #0F172A;
        }

        body:not(.light_theme) .blog_aside_head h3 {
            color: #f2f2f4;
        }

        .blog_aside_head h3::before {
            content: "";
            width: 16px;
            height: 2px;
            border-radius: 2px;
            background: linear-gradient(135deg, #e8c878 0%, #c69a3f 55%, #a87f2c 100%);
        }

        .blog_aside_meta {
            font-size: 12px;
            color: #6c6c75;
        }

        .blog_aside_copy {
            display: inline-flex;
            align-items: center;
            gap: 9px;
            height: 40px;
            padding: 0 18px;
            border-radius: 20px;
            border: 1px solid rgba(15, 23, 42, 0.12);
            background: transparent;
            font-size: 13px;
            font-weight: 600;
            color: #6B7280;
            cursor: pointer;
            transition: color 0.18s, border-color 0.18s, background 0.18s;
        }

        body:not(.light_theme) .blog_aside_copy {
            border-color: rgba(255, 255, 255, 0.08);
            color: #9a9aa3;
        }

        .blog_aside_copy svg {
            width: 15px;
            height: 15px;
            stroke: currentColor;
            fill: none;
            stroke-width: 2;
        }

        .blog_aside_copy:hover,
        .blog_aside_copy.is-copied {
            color: #d4a94e;
            border-color: rgba(212, 169, 78, 0.45);
            background: rgba(212, 169, 78, 0.12);
        }

        .blog_aside_toc {
            list-style: none;
            position: relative;
            padding: 0;
            margin: 0;
        }

        .blog_aside_toc::before {
            content: "";
            position: absolute;
            left: 0;
            top: 6px;
            bottom: 6px;
            width: 1px;
            background: rgba(15, 23, 42, 0.1);
        }

        body:not(.light_theme) .blog_aside_toc::before {
            background: rgba(255, 255, 255, 0.08);
        }

        .blog_aside_toc button {
            display: block;
            position: relative;
            width: 100%;
            padding: 7px 0 7px 18px;
            font-size: 13.5px;
            line-height: 1.45;
            color: #6B7280;
            background: none;
            border: none;
            text-align: left;
            cursor: pointer;
            transition: color 0.15s;
        }

        body:not(.light_theme) .blog_aside_toc button {
            color: #9a9aa3;
        }

        .blog_aside_toc button::before {
            content: "";
            position: absolute;
            left: -1px;
            top: 6px;
            bottom: 6px;
            width: 2px;
            background: transparent;
            border-radius: 2px;
        }

        .blog_aside_toc button:hover {
            color: #0F172A;
        }

        body:not(.light_theme) .blog_aside_toc button:hover {
            color: #f2f2f4;
        }

        .blog_aside_toc button.is-active {
            color: #d4a94e;
            font-weight: 500;
        }

        .blog_aside_toc button.is-active::before {
            background: #d4a94e;
        }

        .blog_aside_rel {
            display: flex;
            gap: 14px;
            padding: 10px 0;
            text-decoration: none;
            color: inherit;
        }

        .blog_aside_rel_thumb {
            width: 66px;
            height: 66px;
            flex-shrink: 0;
            border-radius: 12px;
            background: radial-gradient(120% 120% at 20% 0%, rgba(212, 169, 78, 0.16), rgba(15, 23, 42, 0.04) 60%);
            border: 1px solid rgba(15, 23, 42, 0.1);
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            transition: border-color 0.15s;
        }

        body:not(.light_theme) .blog_aside_rel_thumb {
            background: radial-gradient(120% 120% at 20% 0%, rgba(212, 169, 78, 0.16), rgba(255, 255, 255, 0.02) 60%);
            border-color: rgba(255, 255, 255, 0.08);
        }

        .blog_aside_rel:hover .blog_aside_rel_thumb {
            border-color: rgba(212, 169, 78, 0.4);
        }

        .blog_aside_rel_thumb svg {
            width: 26px;
            height: 26px;
        }

        .blog_aside_rel_thumb img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        .blog_aside_rel_body {
            min-width: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: 5px;
        }

        .blog_aside_rel_kicker {
            font-size: 11.5px;
            color: #d4a94e;
            font-weight: 600;
        }

        .blog_aside_rel_title {
            font-size: 13.5px;
            font-weight: 600;
            line-height: 1.4;
            color: #0F172A;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            transition: color 0.15s;
        }

        body:not(.light_theme) .blog_aside_rel_title {
            color: #f2f2f4;
        }

        .blog_aside_rel:hover .blog_aside_rel_title {
            color: #d4a94e;
        }

        .blog_aside_rel_meta {
            font-size: 12px;
            color: #6c6c75;
        }

        .blog_aside_viewall {
            display: inline-flex;
            align-items: center;
            gap: 7px;
            margin-top: 10px;
            font-size: 13px;
            font-weight: 600;
            color: #6B7280;
            text-decoration: none;
            transition: color 0.15s;
        }

        body:not(.light_theme) .blog_aside_viewall {
            color: #9a9aa3;
        }

        .blog_aside_viewall:hover {
            color: #d4a94e;
        }

        .blog_aside_viewall svg {
            width: 13px;
            height: 13px;
            stroke: currentColor;
            fill: none;
            stroke-width: 2.2;
        }

        .blog_aside_cta {
            margin-top: 2px;
            border-radius: 16px;
            padding: 1px;
            background: linear-gradient(150deg, rgba(198, 154, 63, 0.55), rgba(212, 169, 78, 0.12) 45%, rgba(15, 23, 42, 0.06));
        }

        body:not(.light_theme) .blog_aside_cta {
            background: linear-gradient(150deg, rgba(232, 200, 120, 0.55), rgba(212, 169, 78, 0.12) 45%, rgba(255, 255, 255, 0.05));
        }

        .blog_aside_cta_inner {
            border-radius: 15px;
            background:
                radial-gradient(130% 150% at 100% 0%, rgba(212, 169, 78, 0.14), transparent 55%),
                #ffffff;
            padding: 22px 20px;
        }

        body:not(.light_theme) .blog_aside_cta_inner {
            background:
                radial-gradient(130% 150% at 100% 0%, rgba(212, 169, 78, 0.14), transparent 55%),
                #101013;
        }

        .blog_aside_cta_inner h4 {
            font-size: 15px;
            font-weight: 700;
            margin: 0 0 6px;
            letter-spacing: -0.005em;
            color: #0F172A;
        }

        body:not(.light_theme) .blog_aside_cta_inner h4 {
            color: #f2f2f4;
        }

        .blog_aside_cta_inner p {
            font-size: 13px;
            line-height: 1.55;
            color: #6B7280;
            margin: 0 0 16px;
        }

        body:not(.light_theme) .blog_aside_cta_inner p {
            color: #9a9aa3;
        }

        .blog_aside_cta_btn {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 42px;
            border-radius: 10px;
            background: linear-gradient(135deg, #e8c878 0%, #c69a3f 55%, #a87f2c 100%);
            color: #171204;
            font-size: 13.5px;
            font-weight: 700;
            text-decoration: none;
            transition: filter 0.15s, transform 0.15s;
        }

        .blog_aside_cta_btn:hover {
            filter: brightness(1.06);
            color: #171204;
            text-decoration: none;
        }

        .blog_aside_toast {
            position: fixed;
            bottom: 28px;
            left: 50%;
            transform: translate(-50%, 12px);
            background: #1c1c22;
            border: 1px solid rgba(255, 255, 255, 0.12);
            color: #f2f2f4;
            font-size: 13px;
            font-weight: 500;
            padding: 10px 18px;
            border-radius: 10px;
            opacity: 0;
            pointer-events: none;
            z-index: 2000;
            transition: opacity 0.25s, transform 0.25s;
        }

        .blog_aside_toast.is-show {
            opacity: 1;
            transform: translate(-50%, 0);
        }

        @media (min-width: 768px) {
            .blog_detail_layout {
                grid-template-columns: minmax(0, 1fr) minmax(220px, 280px);
                gap: 32px 28px;
            }

            .blog_detail_sidebar {
                align-self: start;
            }

            .blog_aside {
                padding-left: 24px;
                max-height: calc(100vh - 112px);
                overflow-y: auto;
                overscroll-behavior: contain;
                scrollbar-width: thin;
                padding-right: 6px;
                gap: 26px;
            }

            body:not(.light_theme) .blog_aside {
                border-left-color: rgba(255, 255, 255, 0.08);
            }
        }

        @media (min-width: 992px) {
            .blog_detail_layout {
                grid-template-columns: minmax(0, 1fr) minmax(250px, 320px);
                gap: 40px 48px;
            }

            .blog_aside {
                padding-left: 28px;
            }
        }

        @media (min-width: 1200px) {
            .blog_detail_layout {
                gap: 56px 72px;
            }
        }

        @media (max-width: 767.98px) {
            .blog_detail_page {
                padding: 16px 0 48px;
                overflow-x: hidden;
            }

            .blog_detail_container {
                padding: 0 16px;
                width: 100%;
                max-width: 100%;
            }

            .blog_detail_page .container.blog_detail_container {
                width: 100%;
            }

            .blog_detail_title {
                font-size: 22px;
                letter-spacing: -0.3px;
                word-break: break-word;
            }

            .blog_detail_subtitle {
                font-size: 15px;
            }

            .blog_detail_hero_img_wrap {
                border-radius: 10px;
                margin-bottom: 18px;
            }

            .blog-prose {
                overflow-x: auto;
                font-size: 14.5px;
            }

            .blog-prose h1 {
                font-size: 22px;
            }

            .blog-prose h2 {
                font-size: 18px;
            }

            .blog-prose h3 {
                font-size: 16px;
            }

            .blog_takeaways_card {
                padding: 16px;
            }

            .blog_detail_sidebar {
                margin-top: 4px;
            }

            .blog_aside {
                position: static;
                max-height: none;
                overflow: visible;
            }

            .blog_aside_sec {
                padding: 4px 0 22px;
            }

            .blog_aside_sec+.blog_aside_sec {
                padding-top: 22px;
            }

            .blog_aside_head {
                flex-wrap: wrap;
                gap: 8px;
            }

            .blog_aside_copy {
                width: 100%;
                justify-content: center;
            }

            .blog_aside_toc button {
                word-break: break-word;
            }

            .blog_aside_rel {
                align-items: flex-start;
            }

            .blog_aside_rel_thumb {
                width: 56px;
                height: 56px;
                flex-shrink: 0;
            }

            .blog_aside_cta_inner {
                padding: 18px 16px;
            }

            .blog_aside_toast {
                left: 16px;
                right: 16px;
                width: auto;
                transform: translateY(12px);
                text-align: center;
            }

            .blog_aside_toast.is-show {
                transform: translateY(0);
            }

            .blog_detail_author_meta,
            .blog_detail_author_meta .author_info {
                flex-wrap: wrap;
            }

            .blog_detail_author_meta .meta_time_date {
                line-height: 1.4;
            }
        }

        /* Blog List Dark Theme Overrides */
        body:not(.light_theme) .blog-page {
            background-color: #181a20;
            color: #e2e8f0;
        }

        body:not(.light_theme) .blog-header h1,
        body:not(.light_theme) .featured-post-title,
        body:not(.light_theme) .post-card-title,
        body:not(.light_theme) .sidebar-title,
        body:not(.light_theme) .trending-headline {
            color: #ffffff;
        }

        body:not(.light_theme) .blog-cat-btn {
            background-color: #ffffff14;
            color: #9ca3af;
        }

        body:not(.light_theme) .blog-cat-btn:hover {
            background-color: #2a2a2a;
        }

        body:not(.light_theme) .blog-cat-btn.active {
            background-color: #D3B06C;
            color: #ffffff;
        }

        body:not(.light_theme) .featured-post-card,
        body:not(.light_theme) .post-card,
        body:not(.light_theme) .sidebar-card {
            background: #ffffff08;
            border-color: #222222;
            box-shadow: 0 4px 20px rgb(0 0 0 / 6%);
        }

        body:not(.light_theme) .post-card:hover {
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.6);
        }

        body:not(.light_theme) .post-card-footer {
            border-top-color: #222222;
        }

        body:not(.light_theme) .page-btn {
            background: #ffffff12;
            border-color: #222222;
            color: #9ca3af;
        }

        body:not(.light_theme) .page-btn:hover:not(.active):not(:disabled) {
            background: #1a1a1a;
        }

        body:not(.light_theme) .blog-empty {
            color: #9ca3af;
        }

        body:not(.light_theme) .badge-tag {
            background: rgba(211, 176, 108, 0.1);
        }

        @media (max-width: 767px) {


            .blog_detail_title {
                font-size: 20px;
            }

            .blog-prose ul,
            .blog-prose ol {
                margin: 0 0 10px 0px;
            }

            .blog-prose h1,
            .blog-prose h2,
            .blog-prose h3,
            .blog-prose h4,
            .blog-prose h5,
            .blog-prose h6 {
                margin-top: 12px;
            }

            .blog-page {
                padding: 30px 0 40px 0;
            }

            .blog_detail_subtitle {
                font-size: 14px;
            }

            .blog_section_block .section_p {
                font-size: 14px;
            }

        }`, "",{"version":3,"sources":["webpack://./src/ui/Pages/Blog/blog.css"],"names":[],"mappings":"QAAQ;YACI,gCAAgC;YAChC,yBAAyB;YACzB,cAAc;YACd,qBAAqB;YACrB,kBAAkB;YAClB,gBAAgB;QACpB;;QAEA;YACI,yBAAyB;YACzB,cAAc;QAClB;;QAEA,yBAAyB;QACzB;YACI,kBAAkB;YAClB,SAAS;YACT,UAAU;YACV,WAAW;YACX,YAAY;YACZ,6FAA6F;YAC7F,oBAAoB;YACpB,UAAU;QACd;;QAEA;YACI,kBAAkB;YAClB,QAAQ;YACR,WAAW;YACX,WAAW;YACX,YAAY;YACZ,2FAA2F;YAC3F,oBAAoB;YACpB,UAAU;QACd;;QAEA;YACI,kBAAkB;YAClB,YAAY;YACZ,SAAS;YACT,WAAW;YACX,YAAY;YACZ,6FAA6F;YAC7F,oBAAoB;YACpB,UAAU;QACd;;QAEA;YACI,6FAA6F;QACjG;;QAEA;YACI,2FAA2F;QAC/F;;QAEA,mBAAmB;QACnB;YACI,kBAAkB;YAClB,WAAW;YACX,qBAAqB;QACzB;;QAEA;YACI,qBAAqB;YACrB,eAAe;YACf,gBAAgB;YAChB,yBAAyB;YACzB,mBAAmB;YACnB,cAAc;YACd,oCAAoC;YACpC,iBAAiB;YACjB,mBAAmB;YACnB,mBAAmB;QACvB;;QAEA;YACI,cAAc;YACd,qCAAqC;QACzC;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,gBAAgB;YAChB,gBAAgB;YAChB,mBAAmB;YACnB,8DAA8D;YAC9D,6BAA6B;YAC7B,oCAAoC;QACxC;;QAEA;YACI,8DAA8D;YAC9D,6BAA6B;YAC7B,oCAAoC;QACxC;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,cAAc;YACd,mBAAmB;YACnB,gBAAgB;QACpB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI;gBACI,uCAAuC;YAC3C;;YAEA;gBACI,yCAAyC;YAC7C;;YAEA;gBACI,uCAAuC;YAC3C;QACJ;;QAEA;YACI,0CAA0C;YAC1C,oDAAoD;YACpD,0EAA0E;YAC1E,eAAe;YACf,WAAW;QACf;;QAEA;YACI,gBAAgB;QACpB;;QAEA;YACI,oDAAoD;YACpD,0DAA0D;QAC9D;;QAEA,8BAA8B;QAC9B;YACI,aAAa;YACb,mBAAmB;YACnB,8BAA8B;YAC9B,gBAAgB;YAChB,mBAAmB;YACnB,kBAAkB;YAClB,WAAW;YACX,SAAS;YACT,eAAe;QACnB;;QAEA;YACI,kBAAkB;YAClB,eAAe;YACf,aAAa;YACb,mBAAmB;QACvB;;QAEA;YACI,iCAAiC;YACjC,2CAA2C;YAC3C,kCAA0B;oBAA1B,0BAA0B;YAC1B,mBAAmB;YACnB,YAAY;YACZ,aAAa;YACb,QAAQ;YACR,yCAAyC;YACzC,gBAAgB;YAChB,mBAAmB;YACnB,qBAAqB;YACrB,wBAAwB;QAC5B;;QAEA;YACI,aAAa;QACjB;;QAEA;YACI,kBAAkB;YAClB,QAAQ;YACR,2BAA2B;YAC3B,gBAAgB;YAChB,YAAY;YACZ,WAAW;YACX,WAAW;YACX,YAAY;YACZ,kBAAkB;YAClB,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,eAAe;YACf,WAAW;YACX,uCAAuC;YACvC,eAAe;YACf,UAAU;YACV,cAAc;QAClB;;QAEA;YACI,YAAY;QAChB;;QAEA;YACI,WAAW;QACf;;QAEA;YACI,YAAY;QAChB;;QAEA;YACI,kCAAkC;YAClC,qCAAqC;YACrC,0CAA0C;QAC9C;;QAEA;YACI,eAAe;YACf,kBAAkB;YAClB,eAAe;YACf,gBAAgB;YAChB,cAAc;YACd,mBAAmB;YACnB,qDAAqD;QACzD;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,cAAc;YACd,qCAAqC;QACzC;;QAEA;YACI,cAAc;YACd,+BAA+B;QACnC;;QAEA;YACI,8BAA8B;YAC9B,yBAAyB;YACzB,gBAAgB;YAChB,+CAA+C;QACnD;;QAEA,oBAAoB;QACpB;YACI,kBAAkB;YAClB,gBAAgB;QACpB;;QAEA;YACI,iCAAiC;YACjC,2CAA2C;YAC3C,mBAAmB;YACnB,4BAA4B;YAC5B,cAAc;YACd,eAAe;YACf,WAAW;YACX,aAAa;YACb,oBAAoB;YACpB,kCAA0B;oBAA1B,0BAA0B;YAC1B,0CAA0C;QAC9C;;QAEA;YACI,kCAAkC;YAClC,qCAAqC;YACrC,cAAc;YACd,0CAA0C;QAC9C;;QAEA;YACI,qBAAqB;YACrB,6CAA6C;QACjD;;QAEA;YACI,qBAAqB;QACzB;;QAEA,yCAAyC;QACzC;YACI,yFAAyF;YACzF,2CAA2C;YAC3C,mBAAmB;YACnB,aAAa;YACb,mBAAmB;YACnB,kBAAkB;YAClB,WAAW;YACX,2CAA2C;YAC3C,kCAA0B;oBAA1B,0BAA0B;YAC1B,uDAAuD;YACvD,eAAe;QACnB;;QAEA;YACI,mBAAmB;YACnB,qCAAqC;YACrC,2CAA2C;QAC/C;;QAEA;YACI,2BAA2B;YAC3B,sCAAsC;YACtC,iDAAiD;QACrD;;QAEA;YACI,2CAA2C;YAC3C,sCAAsC;QAC1C;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;QACb;;QAEA;YACI,WAAS;YACT,mBAAmB;YACnB,gBAAgB;YAChB,kBAAkB;YAClB,aAAa;YACb,0CAA0C;QAC9C;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,iBAAiB;YACjB,6DAA6D;QACjE;;QAEA;YACI,sBAAsB;QAC1B;;QAEA;YACI,WAAS;QACb;;QAEA;YACI,aAAa;YACb,SAAS;YACT,mBAAmB;YACnB,mBAAmB;YACnB,UAAU;YACV,gBAAgB;QACpB;;QAEA;YACI,eAAe;YACf,cAAc;YACd,gBAAgB;QACpB;;QAEA;YACI,cAAc;YACd,gBAAgB;YAChB,yBAAyB;YACzB,mBAAmB;QACvB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,iBAAiB;YACjB,cAAc;YACd,mBAAmB;YACnB,sBAAsB;QAC1B;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,cAAc;YACd,mBAAmB;QACvB;;QAEA;YACI,cAAc;QAClB;;QAEA,cAAc;QACd;YACI,oBAAoB;YACpB,mBAAmB;YACnB,QAAQ;YACR,eAAe;YACf,gBAAgB;YAChB,cAAc;YACd,qBAAqB;YACrB,oBAAoB;QACxB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,qBAAqB;QACzB;;QAEA,uBAAuB;QACvB;YACI,aAAa;YACb,8BAA8B;YAC9B,qBAAqB;YACrB,mBAAmB;YACnB,kDAAkD;YAClD,oBAAoB;QACxB;;QAEA;YACI,4CAA4C;QAChD;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,cAAc;YACd,SAAS;QACb;;QAEA;YACI,cAAc;QAClB;;QAEA,8BAA8B;QAC9B;YACI,aAAa;YACb,4DAA4D;YAC5D,SAAS;YACT,kBAAkB;YAClB,WAAW;QACf;;QAEA,4BAA4B;QAC5B;YACI,0FAA0F;YAC1F,2CAA2C;YAC3C,mBAAmB;YACnB,aAAa;YACb,uDAAuD;YACvD,2CAA2C;YAC3C,kCAA0B;oBAA1B,0BAA0B;YAC1B,aAAa;YACb,sBAAsB;YACtB,YAAY;YACZ,eAAe;QACnB;;QAEA;YACI,mBAAmB;YACnB,qCAAqC;YACrC,2CAA2C;QAC/C;;QAEA;YACI,2BAA2B;YAC3B,uCAAuC;YACvC,gDAAgD;QACpD;;QAEA;YACI,2CAA2C;YAC3C,sCAAsC;QAC1C;;QAEA;YACI,mBAAmB;YACnB,gBAAgB;YAChB,kBAAkB;YAClB,aAAa;YACb,mBAAmB;YACnB,0CAA0C;QAC9C;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,iBAAiB;YACjB,6DAA6D;QACjE;;QAEA;YACI,sBAAsB;QAC1B;;QAEA;YACI,aAAa;YACb,8BAA8B;YAC9B,mBAAmB;YACnB,mBAAmB;QACvB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,yBAAyB;YACzB,mBAAmB;YACnB,cAAc;YACd,qCAAqC;YACrC,iBAAiB;YACjB,mBAAmB;QACvB;;QAEA;YACI,cAAc;YACd,qCAAqC;QACzC;;QAEA;YACI,eAAe;YACf,cAAc;QAClB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,gBAAgB;YAChB,iBAAiB;YACjB,cAAc;YACd,mBAAmB;YACnB,sBAAsB;YACtB,oBAAoB;YACpB,qBAAqB;YACrB,4BAA4B;YAC5B,gBAAgB;YAChB,YAAY;QAChB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,cAAc;YACd,mBAAmB;YACnB,oBAAoB;YACpB,qBAAqB;YACrB,4BAA4B;YAC5B,gBAAgB;YAChB,YAAY;QAChB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,gBAAgB;YAChB,iBAAiB;YACjB,+CAA+C;YAC/C,aAAa;YACb,8BAA8B;YAC9B,mBAAmB;QACvB;;QAEA;YACI,yCAAyC;QAC7C;;QAEA,wBAAwB;QACxB;YACI,mBAAmB;YACnB,cAAc;YACd,gBAAgB;YAChB,mBAAmB;YACnB,kBAAkB;YAClB,gDAAgD;YAChD,yBAAyB;YACzB,qBAAqB;YACrB,qBAAqB;YACrB,YAAY;QAChB;;QAEA;YACI,2BAA2B;YAC3B,+CAA+C;QACnD;;QAEA,qBAAqB;QACrB;YACI,mBAAmB;YACnB,2CAA2C;YAC3C,2FAA2F;YAC3F,aAAa;YACb,2CAA2C;YAC3C,mBAAmB;QACvB;;QAEA;YACI,2CAA2C;YAC3C,6DAA6D;YAC7D,2CAA2C;QAC/C;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,iBAAiB;YACjB,cAAc;YACd,mBAAmB;QACvB;;QAEA;YACI,cAAc;QAClB;;QAEA,sBAAsB;QACtB;YACI,gBAAgB;YAChB,mBAAmB;YACnB,2CAA2C;YAC3C,8FAA8F;YAC9F,kBAAkB;YAClB,kBAAkB;YAClB,0CAA0C;YAC1C,gBAAgB;QACpB;;QAEA;YACI,2CAA2C;YAC3C,+EAA+E;YAC/E,2CAA2C;QAC/C;;QAEA;YACI,2BAA2B;YAC3B,uBAAuB;YACvB,yBAAyB;QAC7B;;QAEA;YACI,kCAAkC;YAClC,gBAAgB;QACpB;;QAEA;YACI,8BAA8B;YAC9B,yBAAyB;QAC7B;;QAEA;YACI,gBAAgB;QACpB;;QAEA,oCAAoC;QACpC;YACI,gBAAgB;YAChB,mBAAmB;YACnB,gGAAgG;YAChG,2CAA2C;YAC3C,kBAAkB;YAClB,kBAAkB;YAClB,WAAW;YACX,0CAA0C;YAC1C,kCAA0B;oBAA1B,0BAA0B;QAC9B;;QAEA;YACI,gGAAgG;YAChG,qCAAqC;YACrC,2CAA2C;QAC/C;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,cAAc;YACd,mBAAmB;QACvB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,cAAc;YACd,eAAe;YACf,gBAAgB;QACpB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,uBAAuB;YACvB,yBAAyB;YACzB,yBAAyB;YACzB,gBAAgB;YAChB,eAAe;YACf,yBAAyB;YACzB,mBAAmB;YACnB,kBAAkB;YAClB,mBAAmB;YACnB,oBAAoB;YACpB,qBAAqB;YACrB,qBAAqB;QACzB;;QAEA;YACI,qBAAqB;YACrB,yBAAyB;QAC7B;;QAEA;YACI,mBAAmB;YACnB,yBAAyB;YACzB,+CAA+C;YAC/C,2BAA2B;QAC/B;;QAEA;YACI,mBAAmB;YACnB,yBAAyB;YACzB,8CAA8C;YAC9C,2BAA2B;QAC/B;;QAEA;YACI,gCAAgC;YAChC,cAAc;YACd,yBAAyB;YACzB,oBAAoB;QACxB;;QAEA;YACI,cAAc;YACd,yBAAyB;QAC7B;;QAEA;YACI,kIAAkI;YAClI,iCAAiC;YACjC,sCAAsC;YACtC,+BAA+B;YAC/B,kDAAkD;YAClD,kBAAkB;QACtB;;QAEA;YACI,sHAAsH;YACtH,4CAA4C;QAChD;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,6DAA6D;YAC7D,6BAA6B;YAC7B,oCAAoC;QACxC;;QAEA;YACI,6DAA6D;YAC7D,6BAA6B;YAC7B,oCAAoC;QACxC;;QAEA;YACI,mBAAmB;YACnB,gBAAgB;YAChB,2CAA2C;YAC3C,kCAAkC;YAClC,aAAa;YACb,0CAA0C;YAC1C,kCAA0B;oBAA1B,0BAA0B;QAC9B;;QAEA;YACI,qCAAqC;YACrC,mBAAmB;YACnB,2CAA2C;QAC/C;;QAEA;YACI,mBAAmB;YACnB,gBAAgB;YAChB,mBAAmB;YACnB,0CAA0C;QAC9C;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,iBAAiB;YACjB,iBAAiB;QACrB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,cAAc;YACd,gBAAgB;YAChB,mBAAmB;QACvB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,eAAe;YACf,iBAAiB;YACjB,cAAc;YACd,mBAAmB;YACnB,mBAAmB;QACvB;;QAEA;YACI,cAAc;QAClB;;QAEA,mBAAmB;QACnB;YACI,mBAAmB;YACnB,2CAA2C;YAC3C,kCAAkC;YAClC,kBAAkB;YAClB,0CAA0C;YAC1C,kCAA0B;oBAA1B,0BAA0B;QAC9B;;QAEA;YACI,qCAAqC;YACrC,mBAAmB;YACnB,2CAA2C;QAC/C;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,cAAc;YACd,mBAAmB;YACnB,8BAA8B;YAC9B,kBAAkB;YAClB,yBAAyB;YACzB,qBAAqB;QACzB;;QAEA;YACI,cAAc;YACd,0BAA0B;QAC9B;;QAEA;YACI,eAAe;YACf,qDAAqD;YACrD,kDAAkD;YAClD,eAAe;QACnB;;QAEA;YACI,4CAA4C;QAChD;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,mBAAmB;YACnB,iBAAiB;QACrB;;QAEA;YACI,0BAA0B;QAC9B;;QAEA;YACI,cAAc;YACd,gBAAgB;YAChB,gBAAgB;YAChB,eAAe;YACf,qBAAqB;YACrB,sBAAsB;QAC1B;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,cAAc;QAClB;;QAEA,cAAc;QACd;YACI,yBAAyB;YACzB,gBAAgB;YAChB,eAAe;YACf,qBAAqB;YACrB,oBAAoB;YACpB,oBAAoB;YACpB,mBAAmB;YACnB,QAAQ;QACZ;;QAEA;YACI,yBAAyB;QAC7B;;QAEA;YACI,yBAAyB;QAC7B;;QAEA;YACI,0BAA0B;QAC9B;;QAEA;YACI,2BAA2B;QAC/B;;QAEA;YACI,WAAW;QACf;;;;;;;;;;;;QAYA;YACI,oEAAoE;YACpE,yBAAyB;YACzB,cAAc;YACd,sBAAsB;QAC1B;;QAEA;YACI,iBAAiB;YACjB,cAAc;YACd,eAAe;QACnB;;QAEA,2BAA2B;QAC3B;YACI,mBAAmB;QACvB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,cAAc;YACd,kBAAkB;QACtB;;QAEA;YACI,eAAe;YACf,cAAc;YACd,kBAAkB;QACtB;;QAEA;YACI,aAAa;YACb,gBAAgB;YAChB,SAAS;YACT,eAAe;QACnB;;QAEA;YACI,iBAAiB;YACjB,mBAAmB;YACnB,eAAe;YACf,gBAAgB;YAChB,cAAc;YACd,yBAAyB;YACzB,YAAY;YACZ,eAAe;YACf,oBAAoB;QACxB;;QAEA;YACI,yBAAyB;YACzB,cAAc;YACd,gBAAgB;QACpB;;QAEA,qCAAqC;QACrC;YACI,aAAa;YACb,SAAS;YACT,gBAAgB;QACpB;;QAEA;YACI,aAAa;QACjB;;QAEA;YACI,YAAY;YACZ,cAAc;QAClB;;QAEA,0BAA0B;QAC1B;YACI,mBAAmB;YACnB,yBAAyB;YACzB,mBAAmB;YACnB,gBAAgB;YAChB,mBAAmB;YACnB,0CAA0C;QAC9C;;QAEA;YACI,WAAW;YACX,oBAAoB;YACpB,gBAAgB;YAChB,mBAAmB;QACvB;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,iBAAiB;YACjB,cAAc;QAClB;;QAEA;YACI,eAAe;YACf,cAAc;YACd,cAAc;QAClB;;QAEA;YACI,SAAS;YACT,eAAe;QACnB;;QAEA;YACI,kBAAkB;QACtB;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;YACT,eAAe;YACf,cAAc;YACd,mBAAmB;QACvB;;QAEA;YACI,cAAc;YACd,gBAAgB;YAChB,mBAAmB;YACnB,gBAAgB;YAChB,kBAAkB;QACtB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,cAAc;YACd,gBAAgB;YAChB,mBAAmB;QACvB;;QAEA;YACI,eAAe;YACf,cAAc;YACd,gBAAgB;YAChB,SAAS;QACb;;QAEA,4BAA4B;QAC5B;YACI,aAAa;YACb,qCAAqC;YACrC,SAAS;QACb;;QAEA;YACI,mBAAmB;YACnB,yBAAyB;YACzB,mBAAmB;YACnB,gBAAgB;YAChB,aAAa;YACb,sBAAsB;YACtB,sCAAsC;YACtC,2CAA2C;QAC/C;;QAEA;YACI,2BAA2B;YAC3B,0CAA0C;QAC9C;;QAEA;YACI,WAAW;YACX,aAAa;YACb,iBAAiB;QACrB;;QAEA;YACI,aAAa;YACb,aAAa;YACb,sBAAsB;YACtB,SAAO;QACX;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,cAAc;YACd,gBAAgB;YAChB,aAAa;YACb,oBAAoB;YACpB,qBAAqB;YACrB,4BAA4B;YAC5B,gBAAgB;QACpB;;QAEA;YACI,eAAe;YACf,cAAc;YACd,gBAAgB;YAChB,mBAAmB;YACnB,oBAAoB;YACpB,qBAAqB;YACrB,4BAA4B;YAC5B,gBAAgB;YAChB,SAAO;QACX;;QAEA;YACI,aAAa;YACb,8BAA8B;YAC9B,mBAAmB;YACnB,eAAe;YACf,cAAc;YACd,6BAA6B;YAC7B,iBAAiB;QACrB;;QAEA;YACI,cAAc;YACd,gBAAgB;YAChB,qBAAqB;YACrB,oBAAoB;QACxB;;QAEA;YACI,cAAc;QAClB;;QAEA,qCAAqC;QACrC;YACI,mBAAmB;YACnB,yBAAyB;YACzB,mBAAmB;YACnB,kBAAkB;YAClB,sCAAsC;QAC1C;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,cAAc;YACd,kBAAkB;QACtB;;QAEA;YACI,aAAa;YACb,sBAAsB;YACtB,SAAS;QACb;;QAEA;YACI,aAAa;YACb,uBAAuB;YACvB,SAAS;QACb;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,kBAAkB;YAClB,mBAAmB;YACnB,cAAc;YACd,eAAe;YACf,gBAAgB;YAChB,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,cAAc;YACd,eAAe;QACnB;;QAEA;YACI,SAAO;QACX;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,cAAc;YACd,gBAAgB;YAChB,iBAAiB;YACjB,oBAAoB;YACpB,qBAAqB;YACrB,4BAA4B;YAC5B,gBAAgB;YAChB,eAAe;QACnB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,eAAe;YACf,cAAc;QAClB;;QAEA,uBAAuB;QACvB;YACI,aAAa;YACb,uBAAuB;YACvB,mBAAmB;YACnB,QAAQ;YACR,gBAAgB;QACpB;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,kBAAkB;YAClB,yBAAyB;YACzB,mBAAmB;YACnB,cAAc;YACd,eAAe;YACf,gBAAgB;YAChB,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,eAAe;YACf,oBAAoB;QACxB;;QAEA;YACI,mBAAmB;YACnB,cAAc;YACd,qBAAqB;QACzB;;QAEA;YACI,mBAAmB;QACvB;;QAEA;YACI,YAAY;YACZ,mBAAmB;QACvB;;QAEA;;YAEI;gBACI,cAAc;YAClB;;QAEJ;;;QAGA;;YAEI;gBACI,eAAe;YACnB;;YAEA;gBACI,qCAAqC;YACzC;;QAEJ;;;QAGA,mCAAmC;QACnC;;YAEI;gBACI,sBAAsB;YAC1B;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,WAAW;YACf;;YAEA;gBACI,qCAAqC;YACzC;QACJ;;QAEA;;YAEI;gBACI,eAAe;YACnB;;YAEA;gBACI,0BAA0B;YAC9B;;;YAGA;gBACI,eAAe;gBACf,kBAAkB;YACtB;;YAEA;gBACI,iBAAiB;gBACjB,eAAe;YACnB;;YAEA;gBACI,SAAS;gBACT,eAAe;YACnB;;YAEA;gBACI,aAAa;YACjB;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,mBAAmB;YACvB;;;QAGJ;;;;;;;;;;;;;;;;;;;;QAoBA;;YAEI;gBACI,eAAe;YACnB;QACJ;;QAEA;;YAEI;gBACI,eAAe;YACnB;;YAEA;gBACI,UAAU;YACd;;YAEA;gBACI,eAAe;gBACf,UAAU;YACd;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,oBAAoB;YACxB;;YAEA;gBACI,kBAAkB;YACtB;;;QAGJ;;;QAGA,mBAAmB;QACnB;;YAEI;gBACI,aAAa;YACjB;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,+BAA+B;YACnC;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,sBAAsB;gBACtB,SAAS;YACb;;YAEA;gBACI,WAAW;gBACX,aAAa;YACjB;;YAEA;gBACI,aAAa;gBACb,kBAAkB;YACtB;;YAEA;gBACI,sBAAsB;YAC1B;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,2BAA2B;YAC/B;;QAEJ;;QAEA;;;YAGI;gBACI,eAAe;YACnB;;YAEA;gBACI,+BAA+B;YACnC;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,oBAAoB;gBACpB,kBAAkB;YACtB;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,aAAa;YACjB;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,sBAAsB;YAC1B;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,eAAe;gBACf,WAAW;gBACX,mBAAmB;YACvB;;YAEA;gBACI,gBAAgB;gBAChB,mBAAmB;YACvB;;YAEA;gBACI,iBAAiB;gBACjB,eAAe;YACnB;;YAEA;gBACI,gBAAgB;YACpB;;YAEA;gBACI,gBAAgB;gBAChB,cAAc;YAClB;;YAEA;gBACI,aAAa;gBACb,mBAAmB;YACvB;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,aAAa;gBACb,gBAAgB;YACpB;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,eAAe;gBACf,iBAAiB;YACrB;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,eAAe;YACnB;;QAEJ;;QAEA;;YAEI;gBACI,eAAe;YACnB;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,SAAS;YACb;;YAEA;gBACI,eAAe;gBACf,mBAAmB;YACvB;;YAEA;gBACI,SAAS;YACb;;YAEA;gBACI,gBAAgB;YACpB;;;YAGA;gBACI,gBAAgB;gBAChB,eAAe;gBACf,mBAAmB;YACvB;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,mBAAmB;YACvB;;YAEA;gBACI,2DAA2D;YAC/D;;YAEA;gBACI,mBAAmB;gBACnB,aAAa;YACjB;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,aAAa;YACjB;;YAEA;gBACI,0BAA0B;gBAC1B,6BAA6B;YACjC;;YAEA;gBACI,kBAAkB;YACtB;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,4BAA4B;gBAC5B,eAAe;YACnB;;;QAGJ;;QAEA;;+EAEuE;;QAEvE;YACI,uFAAuF;YACvF,yBAAyB;YACzB,cAAc;YACd,qBAAqB;YACrB,iBAAiB;QACrB;;QAEA;YACI,yBAAyB;YACzB,cAAc;QAClB;;QAEA;YACI,iBAAiB;YACjB,cAAc;YACd,eAAe;QACnB;;QAEA;YACI,oBAAoB;YACpB,mBAAmB;YACnB,QAAQ;YACR,gBAAgB;YAChB,cAAc;YACd,eAAe;YACf,gBAAgB;YAChB,qBAAqB;YACrB,4BAA4B;QAChC;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,qBAAqB;YACrB,gCAAgC;QACpC;;QAEA;YACI,2BAA2B;QAC/B;;QAEA,kBAAkB;QAClB;YACI,aAAa;YACb,eAAe;YACf,QAAQ;YACR,mBAAmB;QACvB;;QAEA;YACI,qBAAqB;YACrB,eAAe;YACf,gBAAgB;YAChB,cAAc;YACd,mBAAmB;YACnB,iBAAiB;YACjB,kBAAkB;QACtB;;QAEA;YACI,cAAc;YACd,mCAAmC;QACvC;;QAEA,uBAAuB;QACvB;YACI,eAAe;YACf,gBAAgB;YAChB,iBAAiB;YACjB,cAAc;YACd,mBAAmB;YACnB,sBAAsB;QAC1B;;QAEA;YACI,cAAc;QAClB;;QAEA,uBAAuB;QACvB;YACI,eAAe;YACf,gBAAgB;YAChB,cAAc;YACd,mBAAmB;QACvB;;QAEA;YACI,cAAc;QAClB;;QAEA,eAAe;QACf;YACI,WAAW;YACX,oBAAoB;YACpB,gBAAgB;YAChB,mBAAmB;YACnB,mBAAmB;YACnB,2CAA2C;QAC/C;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,oBAAoB;YACpB,iBAAiB;YACjB,cAAc;YACd,wCAAwC;QAC5C;;QAEA;YACI,wCAAwC;QAC5C;;QAEA;YACI,eAAe;YACf,cAAc;YACd,8BAA8B;QAClC;;QAEA;YACI,gBAAgB;QACpB;;QAEA;YACI,cAAc;QAClB;;QAEA,sBAAsB;QACtB;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;YACT,mBAAmB;QACvB;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,kBAAkB;YAClB,mBAAmB;YACnB,cAAc;YACd,gBAAgB;YAChB,eAAe;YACf,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,cAAc;YACd,gBAAgB;QACpB;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,iBAAiB;QACrB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,cAAc;QAClB;;QAEA;YACI,cAAc;QAClB;;QAEA;;;;;;YAMI,gBAAgB;YAChB,cAAc;YACd,gBAAgB;YAChB,mBAAmB;YACnB,wBAAwB;QAC5B;;QAEA;YACI,eAAe;QACnB;;QAEA;YACI,eAAe;QACnB;;QAEA;YACI,eAAe;QACnB;;QAEA;YACI,eAAe;QACnB;;QAEA;;YAEI,eAAe;QACnB;;QAEA;;;;;;YAMI,cAAc;QAClB;;QAEA;YACI,mBAAmB;QACvB;;QAEA;YACI,iBAAiB;QACrB;;QAEA;YACI,cAAc;YACd,gBAAgB;QACpB;;QAEA;YACI,kBAAkB;QACtB;;QAEA;YACI,mBAAmB;YACnB,iBAAiB;QACrB;;QAEA;YACI,eAAe;YACf,YAAY;YACZ,kBAAkB;QACtB;;QAEA;;;;;;YAMI,iBAAiB;YACjB,gBAAgB;YAChB,eAAe;QACnB;;QAEA;;YAEI,iBAAiB;YACjB,eAAe;YACf,sBAAsB;QAC1B;;QAEA;YACI,WAAW;YACX,eAAe;YACf,yBAAyB;YACzB,gBAAgB;QACpB;;QAEA;;YAEI,yBAAyB;YACzB,iBAAiB;YACjB,mBAAmB;YACnB,sBAAsB;QAC1B;;QAEA;;YAEI,sBAAsB;QAC1B;;QAEA;YACI,kBAAkB;QACtB;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,QAAQ;YACR,eAAe;QACnB;;QAEA;YACI,gBAAgB;YAChB,cAAc;QAClB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,cAAc;QAClB;;QAEA,uBAAuB;QACvB;YACI,mBAAmB;YACnB,yBAAyB;YACzB,mBAAmB;YACnB,kBAAkB;YAClB,aAAa;YACb,uBAAuB;YACvB,SAAS;YACT,mBAAmB;QACvB;;QAEA;YACI,mCAAmC;YACnC,oCAAoC;QACxC;;QAEA;YACI,eAAe;YACf,cAAc;QAClB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,cAAc;QAClB;;QAEA;YACI,cAAc;QAClB;;QAEA,qBAAqB;QACrB;YACI,mBAAmB;YACnB,yBAAyB;YACzB,mBAAmB;YACnB,aAAa;YACb,mBAAmB;QACvB;;QAEA;YACI,qBAAqB;YACrB,uCAAuC;QAC3C;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,cAAc;YACd,mBAAmB;QACvB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,gBAAgB;YAChB,UAAU;YACV,SAAS;YACT,aAAa;YACb,sBAAsB;YACtB,SAAS;QACb;;QAEA;YACI,aAAa;YACb,uBAAuB;YACvB,QAAQ;YACR,eAAe;YACf,gBAAgB;YAChB,cAAc;QAClB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,gBAAgB;YAChB,cAAc;YACd,cAAc;QAClB;;QAEA,kBAAkB;QAClB;YACI,mBAAmB;QACvB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,cAAc;YACd,gBAAgB;YAChB,mBAAmB;QACvB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,cAAc;YACd,mBAAmB;QACvB;;QAEA;YACI,cAAc;QAClB;;QAEA,wBAAwB;QACxB;YACI,gBAAgB;YAChB,UAAU;YACV,cAAc;YACd,aAAa;YACb,sBAAsB;YACtB,SAAS;QACb;;QAEA;YACI,aAAa;YACb,uBAAuB;YACvB,SAAS;QACb;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,kBAAkB;YAClB,mBAAmB;YACnB,cAAc;YACd,eAAe;YACf,gBAAgB;YAChB,oBAAoB;YACpB,mBAAmB;YACnB,uBAAuB;YACvB,cAAc;QAClB;;QAEA;YACI,kCAAkC;YAClC,cAAc;QAClB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,cAAc;YACd,eAAe;QACnB;;QAEA;YACI,cAAc;QAClB;;QAEA,sBAAsB;QACtB;YACI,aAAa;YACb,8BAA8B;YAC9B,SAAS;YACT,mBAAmB;QACvB;;QAEA;YACI,mBAAmB;YACnB,aAAa;YACb,kBAAkB;QACtB;;QAEA;YACI,mBAAmB;YACnB,yBAAyB;QAC7B;;QAEA;YACI,kCAAkC;YAClC,oCAAoC;QACxC;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,mBAAmB;YACnB,yBAAyB;QAC7B;;QAEA;YACI,mCAAmC;YACnC,qCAAqC;QACzC;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,eAAe;YACf,kBAAkB;QACtB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,gBAAgB;YAChB,kBAAkB;QACtB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,yBAAyB;YACzB,qBAAqB;QACzB;;QAEA,mBAAmB;QACnB;YACI,gBAAgB;YAChB,UAAU;YACV,cAAc;YACd,aAAa;YACb,sBAAsB;YACtB,SAAS;QACb;;QAEA;YACI,aAAa;YACb,uBAAuB;YACvB,SAAS;QACb;;QAEA;YACI,cAAc;YACd,eAAe;YACf,gBAAgB;YAChB,cAAc;YACd,eAAe;QACnB;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,cAAc;QAClB;;QAEA;YACI,cAAc;QAClB;;QAEA,8CAA8C;QAC9C;YACI,aAAa;YACb,0BAA0B;YAC1B,SAAS;YACT,kBAAkB;YAClB,YAAY;QAChB;;QAEA;;YAEI,YAAY;QAChB;;QAEA;YACI,iBAAiB;YACjB,eAAe;YACf,kBAAkB;YAClB,aAAa;YACb,sBAAsB;YACtB,mBAAmB;YACnB,qBAAqB;YACrB,wCAAwC;YACxC,qCAAqC;QACzC;;QAEA;;YAEI,kDAAkD;QACtD;;QAEA;YACI,UAAU;YACV,WAAW;QACf;;QAEA;YACI,uBAAuB;QAC3B;;QAEA;YACI,uBAAuB;YACvB,mBAAmB;YACnB,8CAAsC;YAAtC,sCAAsC;QAC1C;;QAEA;;YAEI,iCAAiC;QACrC;;QAEA;YACI,kCAAkC;QACtC;;QAEA;;;YAGI,mBAAmB;YACnB,wCAAwC;QAC5C;;QAEA;;;;;;YAMI,qDAAqD;QACzD;;QAEA;;;;;;YAMI,oCAAoC;QACxC;;QAEA;;;YAGI,qCAAqC;QACzC;;QAEA;YACI,4CAA4C;QAChD;;QAEA;YACI,aAAa;YACb,yBAAyB;YACzB,mBAAmB;QACvB;;QAEA;YACI,yBAAyB;QAC7B;;QAEA;YACI,2CAA2C;YAC3C,iBAAiB;QACrB;;QAEA;YACI,2CAA2C;QAC/C;;QAEA;YACI,aAAa;YACb,qBAAqB;YACrB,8BAA8B;YAC9B,mBAAmB;QACvB;;QAEA;YACI,iBAAiB;YACjB,gBAAgB;YAChB,sBAAsB;YACtB,SAAS;YACT,aAAa;YACb,mBAAmB;YACnB,QAAQ;YACR,cAAc;QAClB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,WAAW;YACX,WAAW;YACX,WAAW;YACX,kBAAkB;YAClB,0EAA0E;QAC9E;;QAEA;YACI,eAAe;YACf,cAAc;QAClB;;QAEA;YACI,oBAAoB;YACpB,mBAAmB;YACnB,QAAQ;YACR,YAAY;YACZ,eAAe;YACf,mBAAmB;YACnB,wCAAwC;YACxC,uBAAuB;YACvB,eAAe;YACf,gBAAgB;YAChB,cAAc;YACd,eAAe;YACf,6DAA6D;QACjE;;QAEA;YACI,uCAAuC;YACvC,cAAc;QAClB;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,oBAAoB;YACpB,UAAU;YACV,eAAe;QACnB;;QAEA;;YAEI,cAAc;YACd,sCAAsC;YACtC,oCAAoC;QACxC;;QAEA;YACI,gBAAgB;YAChB,kBAAkB;YAClB,UAAU;YACV,SAAS;QACb;;QAEA;YACI,WAAW;YACX,kBAAkB;YAClB,OAAO;YACP,QAAQ;YACR,WAAW;YACX,UAAU;YACV,iCAAiC;QACrC;;QAEA;YACI,qCAAqC;QACzC;;QAEA;YACI,cAAc;YACd,kBAAkB;YAClB,WAAW;YACX,uBAAuB;YACvB,iBAAiB;YACjB,iBAAiB;YACjB,cAAc;YACd,gBAAgB;YAChB,YAAY;YACZ,gBAAgB;YAChB,eAAe;YACf,uBAAuB;QAC3B;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,WAAW;YACX,kBAAkB;YAClB,UAAU;YACV,QAAQ;YACR,WAAW;YACX,UAAU;YACV,uBAAuB;YACvB,kBAAkB;QACtB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,cAAc;YACd,gBAAgB;QACpB;;QAEA;YACI,mBAAmB;QACvB;;QAEA;YACI,aAAa;YACb,SAAS;YACT,eAAe;YACf,qBAAqB;YACrB,cAAc;QAClB;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,cAAc;YACd,mBAAmB;YACnB,sGAAsG;YACtG,uCAAuC;YACvC,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,gBAAgB;YAChB,8BAA8B;QAClC;;QAEA;YACI,yGAAyG;YACzG,uCAAuC;QAC3C;;QAEA;YACI,qCAAqC;QACzC;;QAEA;YACI,WAAW;YACX,YAAY;QAChB;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,iBAAiB;QACrB;;QAEA;YACI,YAAY;YACZ,aAAa;YACb,sBAAsB;YACtB,uBAAuB;YACvB,QAAQ;QACZ;;QAEA;YACI,iBAAiB;YACjB,cAAc;YACd,gBAAgB;QACpB;;QAEA;YACI,iBAAiB;YACjB,gBAAgB;YAChB,gBAAgB;YAChB,cAAc;YACd,oBAAoB;YACpB,qBAAqB;YACrB,4BAA4B;YAC5B,gBAAgB;YAChB,uBAAuB;QAC3B;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,eAAe;YACf,cAAc;QAClB;;QAEA;YACI,oBAAoB;YACpB,mBAAmB;YACnB,QAAQ;YACR,gBAAgB;YAChB,eAAe;YACf,gBAAgB;YAChB,cAAc;YACd,qBAAqB;YACrB,uBAAuB;QAC3B;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,oBAAoB;YACpB,UAAU;YACV,iBAAiB;QACrB;;QAEA;YACI,eAAe;YACf,mBAAmB;YACnB,YAAY;YACZ,mHAAmH;QACvH;;QAEA;YACI,uHAAuH;QAC3H;;QAEA;YACI,mBAAmB;YACnB;;uBAEW;YACX,kBAAkB;QACtB;;QAEA;YACI;;uBAEW;QACf;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,eAAe;YACf,wBAAwB;YACxB,cAAc;QAClB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,eAAe;YACf,iBAAiB;YACjB,cAAc;YACd,gBAAgB;QACpB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,oBAAoB;YACpB,mBAAmB;YACnB,uBAAuB;YACvB,WAAW;YACX,YAAY;YACZ,mBAAmB;YACnB,0EAA0E;YAC1E,cAAc;YACd,iBAAiB;YACjB,gBAAgB;YAChB,qBAAqB;YACrB,yCAAyC;QAC7C;;QAEA;YACI,wBAAwB;YACxB,cAAc;YACd,qBAAqB;QACzB;;QAEA;YACI,eAAe;YACf,YAAY;YACZ,SAAS;YACT,gCAAgC;YAChC,mBAAmB;YACnB,2CAA2C;YAC3C,cAAc;YACd,eAAe;YACf,gBAAgB;YAChB,kBAAkB;YAClB,mBAAmB;YACnB,UAAU;YACV,oBAAoB;YACpB,aAAa;YACb,0CAA0C;QAC9C;;QAEA;YACI,UAAU;YACV,6BAA6B;QACjC;;QAEA;YACI;gBACI,0DAA0D;gBAC1D,cAAc;YAClB;;YAEA;gBACI,iBAAiB;YACrB;;YAEA;gBACI,kBAAkB;gBAClB,+BAA+B;gBAC/B,gBAAgB;gBAChB,4BAA4B;gBAC5B,qBAAqB;gBACrB,kBAAkB;gBAClB,SAAS;YACb;;YAEA;gBACI,4CAA4C;YAChD;QACJ;;QAEA;YACI;gBACI,0DAA0D;gBAC1D,cAAc;YAClB;;YAEA;gBACI,kBAAkB;YACtB;QACJ;;QAEA;YACI;gBACI,cAAc;YAClB;QACJ;;QAEA;YACI;gBACI,oBAAoB;gBACpB,kBAAkB;YACtB;;YAEA;gBACI,eAAe;gBACf,WAAW;gBACX,eAAe;YACnB;;YAEA;gBACI,WAAW;YACf;;YAEA;gBACI,eAAe;gBACf,sBAAsB;gBACtB,sBAAsB;YAC1B;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,mBAAmB;gBACnB,mBAAmB;YACvB;;YAEA;gBACI,gBAAgB;gBAChB,iBAAiB;YACrB;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,aAAa;YACjB;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,gBAAgB;gBAChB,gBAAgB;gBAChB,iBAAiB;YACrB;;YAEA;gBACI,mBAAmB;YACvB;;YAEA;gBACI,iBAAiB;YACrB;;YAEA;gBACI,eAAe;gBACf,QAAQ;YACZ;;YAEA;gBACI,WAAW;gBACX,uBAAuB;YAC3B;;YAEA;gBACI,sBAAsB;YAC1B;;YAEA;gBACI,uBAAuB;YAC3B;;YAEA;gBACI,WAAW;gBACX,YAAY;gBACZ,cAAc;YAClB;;YAEA;gBACI,kBAAkB;YACtB;;YAEA;gBACI,UAAU;gBACV,WAAW;gBACX,WAAW;gBACX,2BAA2B;gBAC3B,kBAAkB;YACtB;;YAEA;gBACI,wBAAwB;YAC5B;;YAEA;;gBAEI,eAAe;YACnB;;YAEA;gBACI,gBAAgB;YACpB;QACJ;;QAEA,mCAAmC;QACnC;YACI,yBAAyB;YACzB,cAAc;QAClB;;QAEA;;;;;YAKI,cAAc;QAClB;;QAEA;YACI,2BAA2B;YAC3B,cAAc;QAClB;;QAEA;YACI,yBAAyB;QAC7B;;QAEA;YACI,yBAAyB;YACzB,cAAc;QAClB;;QAEA;;;YAGI,qBAAqB;YACrB,qBAAqB;YACrB,sCAAsC;QAC1C;;QAEA;YACI,yCAAyC;QAC7C;;QAEA;YACI,yBAAyB;QAC7B;;QAEA;YACI,qBAAqB;YACrB,qBAAqB;YACrB,cAAc;QAClB;;QAEA;YACI,mBAAmB;QACvB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,oCAAoC;QACxC;;QAEA;;;YAGI;gBACI,eAAe;YACnB;;YAEA;;gBAEI,oBAAoB;YACxB;;YAEA;;;;;;gBAMI,gBAAgB;YACpB;;YAEA;gBACI,sBAAsB;YAC1B;;YAEA;gBACI,eAAe;YACnB;;YAEA;gBACI,eAAe;YACnB;;QAEJ","sourcesContent":["        .blog_section_b {\n            font-family: 'Inter', sans-serif;\n            background-color: #080A10;\n            color: #E2E8F0;\n            padding-bottom: 120px;\n            position: relative;\n            overflow: hidden;\n        }\n\n        body.light_theme .blog_section_b {\n            background-color: #F8FAFC;\n            color: #0F172A;\n        }\n\n        /* Ambient Glow Spheres */\n        .blog_glow_1 {\n            position: absolute;\n            top: -10%;\n            left: -10%;\n            width: 50vw;\n            height: 50vw;\n            background: radial-gradient(circle, rgba(209, 170, 103, 0.08) 0%, rgba(209, 170, 103, 0) 70%);\n            pointer-events: none;\n            z-index: 1;\n        }\n\n        .blog_glow_2 {\n            position: absolute;\n            top: 40%;\n            right: -10%;\n            width: 45vw;\n            height: 45vw;\n            background: radial-gradient(circle, rgba(123, 97, 255, 0.06) 0%, rgba(123, 97, 255, 0) 70%);\n            pointer-events: none;\n            z-index: 1;\n        }\n\n        .blog_glow_3 {\n            position: absolute;\n            bottom: -10%;\n            left: 15%;\n            width: 40vw;\n            height: 40vw;\n            background: radial-gradient(circle, rgba(209, 170, 103, 0.05) 0%, rgba(209, 170, 103, 0) 70%);\n            pointer-events: none;\n            z-index: 1;\n        }\n\n        body.light_theme .blog_glow_1 {\n            background: radial-gradient(circle, rgba(209, 170, 103, 0.04) 0%, rgba(209, 170, 103, 0) 70%);\n        }\n\n        body.light_theme .blog_glow_2 {\n            background: radial-gradient(circle, rgba(123, 97, 255, 0.03) 0%, rgba(123, 97, 255, 0) 70%);\n        }\n\n        /* Hero Container */\n        .blog_section_b .hero_container {\n            position: relative;\n            z-index: 10;\n            padding: 100px 0 80px;\n        }\n\n        .blog_section_b .tag_badge {\n            display: inline-block;\n            font-size: 13px;\n            font-weight: 600;\n            text-transform: uppercase;\n            letter-spacing: 2px;\n            color: #D1AA67;\n            background: rgba(209, 170, 103, 0.1);\n            padding: 6px 16px;\n            border-radius: 50px;\n            margin-bottom: 20px;\n        }\n\n        body.light_theme .blog_section_b .tag_badge {\n            color: #b08226;\n            background: rgba(209, 170, 103, 0.15);\n        }\n\n        .blog_section_b .hero_title {\n            font-size: 56px;\n            font-weight: 700;\n            max-width: 640px;\n            line-height: 1.1;\n            margin-bottom: 20px;\n            background: linear-gradient(135deg, #FFFFFF 30%, #D1AA67 100%);\n            -webkit-background-clip: text;\n            -webkit-text-fill-color: transparent;\n        }\n\n        body.light_theme .blog_section_b .hero_title {\n            background: linear-gradient(135deg, #0F172A 30%, #b08226 100%);\n            -webkit-background-clip: text;\n            -webkit-text-fill-color: transparent;\n        }\n\n        .blog_section_b .hero_desc {\n            font-size: 18px;\n            line-height: 1.6;\n            color: #94A3B8;\n            margin-bottom: 35px;\n            max-width: 600px;\n        }\n\n        body.light_theme .blog_section_b .hero_desc {\n            color: #475569;\n        }\n\n        @keyframes float3D {\n            0% {\n                transform: translateY(0px) rotate(0deg);\n            }\n\n            50% {\n                transform: translateY(-12px) rotate(1deg);\n            }\n\n            100% {\n                transform: translateY(0px) rotate(0deg);\n            }\n        }\n\n        .blog_section_b .top_right_img img {\n            animation: float3D 6s ease-in-out infinite;\n            filter: drop-shadow(0 15px 30px rgba(0, 0, 0, 0.15));\n            transition: transform 0.5s cubic-bezier(0.25, 1, 0.5, 1), filter 0.5s ease;\n            max-width: 100%;\n            width: 100%;\n        }\n\n        .top_right_img.blogbnr_img {\n            max-width: 550px;\n        }\n\n        .blog_section_b .top_right_img img:hover {\n            transform: scale(1.06) rotate(3deg) translateY(-5px);\n            filter: drop-shadow(0 25px 45px rgba(209, 170, 103, 0.35));\n        }\n\n        /* Dynamic Category Tab dock */\n        .blog_section_b .tab_dock_wrapper {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            margin-top: 60px;\n            margin-bottom: 40px;\n            position: relative;\n            z-index: 10;\n            gap: 20px;\n            flex-wrap: wrap;\n        }\n\n        .blog_section_b .category_dock_container {\n            position: relative;\n            max-width: 100%;\n            display: flex;\n            align-items: center;\n        }\n\n        .blog_section_b .category_dock {\n            background: rgba(30, 32, 38, 0.6);\n            border: 1px solid rgba(255, 255, 255, 0.05);\n            backdrop-filter: blur(5px);\n            border-radius: 50px;\n            padding: 6px;\n            display: flex;\n            gap: 4px;\n            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n            overflow-x: auto;\n            white-space: nowrap;\n            scrollbar-width: none;\n            -ms-overflow-style: none;\n        }\n\n        .blog_section_b .category_dock::-webkit-scrollbar {\n            display: none;\n        }\n\n        .dock_scroll_btn {\n            position: absolute;\n            top: 50%;\n            transform: translateY(-50%);\n            background: #fff;\n            border: none;\n            color: #111;\n            width: 28px;\n            height: 28px;\n            border-radius: 50%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            cursor: pointer;\n            z-index: 20;\n            box-shadow: 0 4px 10px rgb(0 0 0 / 10%);\n            font-size: 12px;\n            padding: 0;\n            line-height: 1;\n        }\n\n        .dock_scroll_btn:hover {\n            opacity: 0.9;\n        }\n\n        .dock_scroll_btn.left {\n            left: -10px;\n        }\n\n        .dock_scroll_btn.right {\n            right: -10px;\n        }\n\n        body.light_theme .blog_section_b .category_dock {\n            background: rgb(255 255 255 / 20%);\n            border: 1px solid rgba(0, 0, 0, 0.05);\n            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.03);\n        }\n\n        .blog_section_b .category_dock_item {\n            cursor: pointer;\n            padding: 10px 24px;\n            font-size: 14px;\n            font-weight: 600;\n            color: #94A3B8;\n            border-radius: 50px;\n            transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n        }\n\n        body.light_theme .blog_section_b .category_dock_item {\n            color: #475569;\n        }\n\n        .blog_section_b .category_dock_item:hover {\n            color: #FFFFFF;\n            background: rgba(255, 255, 255, 0.03);\n        }\n\n        body.light_theme .blog_section_b .category_dock_item:hover {\n            color: #0F172A;\n            background: rgba(0, 0, 0, 0.02);\n        }\n\n        .blog_section_b .category_dock_item.active {\n            background: #d1aa67 !important;\n            color: #ffffff !important;\n            font-weight: 600;\n            box-shadow: 0 4px 15px rgba(209, 170, 103, 0.3);\n        }\n\n        /* Live Search Bar */\n        .blog_section_b .search_input_wrap {\n            position: relative;\n            min-width: 280px;\n        }\n\n        .blog_section_b .search_input_wrap input {\n            background: rgba(30, 32, 38, 0.6);\n            border: 1px solid rgba(255, 255, 255, 0.05);\n            border-radius: 50px;\n            padding: 12px 24px 12px 48px;\n            color: #ffffff;\n            font-size: 14px;\n            width: 100%;\n            outline: none;\n            transition: all 0.3s;\n            backdrop-filter: blur(5px);\n            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);\n        }\n\n        body.light_theme .blog_section_b .search_input_wrap input {\n            background: rgb(255 255 255 / 20%);\n            border: 1px solid rgba(0, 0, 0, 0.05);\n            color: #0F172A;\n            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.02);\n        }\n\n        .blog_section_b .search_input_wrap input:focus {\n            border-color: #D1AA67;\n            box-shadow: 0 0 15px rgba(209, 170, 103, 0.2);\n        }\n\n        body.light_theme .blog_section_b .search_input_wrap input:focus {\n            border-color: #b08226;\n        }\n\n        /* Massive Featured Card (Split Layout) */\n        .blog_section_b .featured_card {\n            background: linear-gradient(135deg, rgba(30, 32, 38, 0.5) 0%, rgba(18, 20, 24, 0.8) 100%);\n            border: 1px solid rgba(255, 255, 255, 0.06);\n            border-radius: 30px;\n            padding: 40px;\n            margin-bottom: 60px;\n            position: relative;\n            z-index: 10;\n            box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);\n            backdrop-filter: blur(5px);\n            transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);\n            cursor: pointer;\n        }\n\n        body.light_theme .blog_section_b .featured_card {\n            background: #ffffff;\n            border: 1px solid rgba(0, 0, 0, 0.05);\n            box-shadow: 0 20px 50px rgba(0, 0, 0, 0.04);\n        }\n\n        .blog_section_b .featured_card:hover {\n            transform: translateY(-6px);\n            border-color: rgba(209, 170, 103, 0.3);\n            box-shadow: 0 30px 60px rgba(209, 170, 103, 0.15);\n        }\n\n        body.light_theme .blog_section_b .featured_card:hover {\n            box-shadow: 0 30px 60px rgba(0, 0, 0, 0.08);\n            border-color: rgba(209, 170, 103, 0.4);\n        }\n\n        .blog_section_b .featured_split {\n            display: flex;\n            align-items: center;\n            gap: 48px;\n        }\n\n        .blog_section_b .featured_img_wrapper {\n            flex: 1.1;\n            border-radius: 20px;\n            overflow: hidden;\n            position: relative;\n            height: 340px;\n            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n        }\n\n        .blog_section_b .featured_img_wrapper img {\n            width: 100%;\n            height: 100%;\n            object-fit: cover;\n            transition: transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);\n        }\n\n        .blog_section_b .featured_card:hover .featured_img_wrapper img {\n            transform: scale(1.04);\n        }\n\n        .blog_section_b .featured_content_wrapper {\n            flex: 0.9;\n        }\n\n        .blog_section_b .featured_meta {\n            display: flex;\n            gap: 16px;\n            align-items: center;\n            margin-bottom: 16px;\n            padding: 0;\n            list-style: none;\n        }\n\n        .blog_section_b .featured_meta li {\n            font-size: 13px;\n            color: #64748B;\n            font-weight: 500;\n        }\n\n        .blog_section_b .featured_meta li.featured_cat {\n            color: #D1AA67;\n            font-weight: 700;\n            text-transform: uppercase;\n            letter-spacing: 1px;\n        }\n\n        body.light_theme .blog_section_b .featured_meta li.featured_cat {\n            color: #b08226;\n        }\n\n        .blog_section_b .featured_title {\n            font-size: 36px;\n            font-weight: 700;\n            line-height: 1.25;\n            color: #ffffff;\n            margin-bottom: 18px;\n            transition: color 0.3s;\n        }\n\n        body.light_theme .blog_section_b .featured_title {\n            color: #0F172A;\n        }\n\n        .blog_section_b .featured_card:hover .featured_title {\n            color: #D1AA67;\n        }\n\n        body.light_theme .blog_section_b .featured_card:hover .featured_title {\n            color: #b08226;\n        }\n\n        .blog_section_b .featured_excerpt {\n            font-size: 15px;\n            line-height: 1.6;\n            color: #94A3B8;\n            margin-bottom: 30px;\n        }\n\n        body.light_theme .blog_section_b .featured_excerpt {\n            color: #475569;\n        }\n\n        /* Read link */\n        .blog_section_b .read_more_action {\n            display: inline-flex;\n            align-items: center;\n            gap: 8px;\n            font-size: 15px;\n            font-weight: 700;\n            color: #D1AA67;\n            text-decoration: none;\n            transition: all 0.3s;\n        }\n\n        body.light_theme .blog_section_b .read_more_action {\n            color: #D1AA67;\n        }\n\n        .blog_section_b .read_more_action:hover {\n            letter-spacing: 0.5px;\n        }\n\n        /* Grid Section Title */\n        .blog_section_b .grid_section_header {\n            display: flex;\n            justify-content: space-between;\n            align-items: flex-end;\n            margin-bottom: 35px;\n            border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n            padding-bottom: 16px;\n        }\n\n        body.light_theme .blog_section_b .grid_section_header {\n            border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n        }\n\n        .blog_section_b .grid_section_title {\n            font-size: 28px;\n            font-weight: 700;\n            color: #ffffff;\n            margin: 0;\n        }\n\n        body.light_theme .blog_section_b .grid_section_title {\n            color: #0F172A;\n        }\n\n        /* Modern CSS Grid for Cards */\n        .blog_section_b .blog_cards_grid {\n            display: grid;\n            grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));\n            gap: 32px;\n            position: relative;\n            z-index: 10;\n        }\n\n        /* Glassmorphic Blog Cards */\n        .blog_section_b .modern_blog_card {\n            background: linear-gradient(180deg, rgba(30, 32, 38, 0.45) 0%, rgba(18, 20, 24, 0.8) 100%);\n            border: 1px solid rgba(255, 255, 255, 0.05);\n            border-radius: 24px;\n            padding: 24px;\n            transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);\n            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\n            backdrop-filter: blur(5px);\n            display: flex;\n            flex-direction: column;\n            height: 100%;\n            cursor: pointer;\n        }\n\n        body.light_theme .blog_section_b .modern_blog_card {\n            background: #ffffff;\n            border: 1px solid rgba(0, 0, 0, 0.05);\n            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);\n        }\n\n        .blog_section_b .modern_blog_card:hover {\n            transform: translateY(-8px);\n            border-color: rgba(209, 170, 103, 0.35);\n            box-shadow: 0 20px 40px rgba(209, 170, 103, 0.2);\n        }\n\n        body.light_theme .blog_section_b .modern_blog_card:hover {\n            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.07);\n            border-color: rgba(209, 170, 103, 0.4);\n        }\n\n        .blog_section_b .card_img_box {\n            border-radius: 16px;\n            overflow: hidden;\n            position: relative;\n            height: 200px;\n            margin-bottom: 24px;\n            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);\n        }\n\n        .blog_section_b .card_img_box img {\n            width: 100%;\n            height: 100%;\n            object-fit: cover;\n            transition: transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);\n        }\n\n        .blog_section_b .modern_blog_card:hover .card_img_box img {\n            transform: scale(1.06);\n        }\n\n        .blog_section_b .card_meta_row {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            margin-bottom: 12px;\n        }\n\n        .blog_section_b .card_cat_tag {\n            font-size: 11px;\n            font-weight: 600;\n            text-transform: uppercase;\n            letter-spacing: 1px;\n            color: #D1AA67;\n            background: rgba(209, 170, 103, 0.08);\n            padding: 4px 12px;\n            border-radius: 30px;\n        }\n\n        body.light_theme .blog_section_b .card_cat_tag {\n            color: #D1AA67;\n            background: rgba(209, 170, 103, 0.12);\n        }\n\n        .blog_section_b .card_read_time {\n            font-size: 12px;\n            color: #64748B;\n        }\n\n        .blog_section_b .card_title {\n            font-size: 20px;\n            text-align: left;\n            font-weight: 700;\n            line-height: 1.35;\n            color: #ffffff;\n            margin-bottom: 12px;\n            transition: color 0.3s;\n            display: -webkit-box;\n            -webkit-line-clamp: 2;\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n            height: 54px;\n        }\n\n        body.light_theme .blog_section_b .card_title {\n            color: #0F172A;\n        }\n\n        .blog_section_b .modern_blog_card:hover .card_title {\n            color: #D1AA67;\n        }\n\n        body.light_theme .blog_section_b .modern_blog_card:hover .card_title {\n            color: #b08226;\n        }\n\n        .blog_section_b .card_desc {\n            font-size: 14px;\n            line-height: 1.5;\n            color: #94A3B8;\n            margin-bottom: 24px;\n            display: -webkit-box;\n            -webkit-line-clamp: 3;\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n            height: 63px;\n        }\n\n        body.light_theme .blog_section_b .card_desc {\n            color: #475569;\n        }\n\n        .blog_section_b .card_footer_action {\n            margin-top: auto;\n            padding-top: 16px;\n            border-top: 1px solid rgba(255, 255, 255, 0.05);\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n        }\n\n        body.light_theme .blog_section_b .card_footer_action {\n            border-top: 1px solid rgba(0, 0, 0, 0.05);\n        }\n\n        /* Start Button styles */\n        .blog_section_b .startbtn {\n            background: #D1AA67;\n            color: #ffffff;\n            font-weight: 600;\n            border-radius: 50px;\n            padding: 12px 36px;\n            box-shadow: 0 4px 15px rgba(209, 170, 103, 0.35);\n            transition: all 0.3s ease;\n            display: inline-block;\n            text-decoration: none;\n            border: none;\n        }\n\n        .blog_section_b .startbtn:hover {\n            transform: translateY(-2px);\n            box-shadow: 0 8px 24px rgba(209, 170, 103, 0.5);\n        }\n\n        /* CTA Card styling */\n        .blog_section_b .crypto_cta {\n            border-radius: 24px;\n            border: 1px solid rgba(255, 255, 255, 0.06);\n            background: linear-gradient(135deg, rgba(30, 32, 38, 0.85) 0%, rgba(20, 22, 26, 0.95) 100%);\n            padding: 48px;\n            box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);\n            margin-bottom: 40px;\n        }\n\n        body.light_theme .blog_section_b .crypto_cta {\n            border: 1px solid rgba(209, 170, 103, 0.15);\n            background: linear-gradient(135deg, #ffffff 0%, #f4f6f9 100%);\n            box-shadow: 0 12px 40px rgba(0, 0, 0, 0.04);\n        }\n\n        .blog_section_b .crypto_cta h3 {\n            font-size: 30px;\n            font-weight: 700;\n            line-height: 1.35;\n            color: #ffffff;\n            margin-bottom: 20px;\n        }\n\n        body.light_theme .blog_section_b .crypto_cta h3 {\n            color: #1e2329;\n        }\n\n        /* Subscribe Section */\n        .blog_section_b .subscribe_form {\n            margin-top: 60px;\n            border-radius: 24px;\n            border: 1px solid rgba(255, 255, 255, 0.08);\n            background: linear-gradient(135deg, rgba(209, 170, 103, 0.08) 0%, rgba(12, 14, 18, 0.95) 100%);\n            padding: 40px 60px;\n            position: relative;\n            box-shadow: 0 15px 45px rgba(0, 0, 0, 0.3);\n            overflow: hidden;\n        }\n\n        body.light_theme .blog_section_b .subscribe_form {\n            border: 1px solid rgba(209, 170, 103, 0.15);\n            background: linear-gradient(135deg, rgba(209, 170, 103, 0.05) 0%, #ffffff 100%);\n            box-shadow: 0 15px 45px rgba(0, 0, 0, 0.04);\n        }\n\n        .blog_section_b .subscribe-input {\n            background: none !important;\n            border: none !important;\n            color: #ffffff !important;\n        }\n\n        .blog_section_b .subscribe-input:focus {\n            border-color: #d1aa6700 !important;\n            box-shadow: none;\n        }\n\n        body.light_theme .blog_section_b .subscribe-input {\n            background: #ffffff !important;\n            color: #1e2329 !important;\n        }\n\n        body.light_theme .blog_section_b .subscribe-input:focus {\n            box-shadow: none;\n        }\n\n        /* Help Callout card at the bottom */\n        .blog_section_b .help_callout_box {\n            margin-top: 80px;\n            border-radius: 28px;\n            background: linear-gradient(135deg, rgba(123, 97, 255, 0.08) 0%, rgba(209, 170, 103, 0.08) 100%);\n            border: 1px solid rgba(255, 255, 255, 0.05);\n            padding: 50px 60px;\n            position: relative;\n            z-index: 10;\n            box-shadow: 0 15px 45px rgba(0, 0, 0, 0.2);\n            backdrop-filter: blur(5px);\n        }\n\n        body.light_theme .blog_section_b .help_callout_box {\n            background: linear-gradient(135deg, rgba(123, 97, 255, 0.03) 0%, rgba(209, 170, 103, 0.03) 100%);\n            border: 1px solid rgba(0, 0, 0, 0.05);\n            box-shadow: 0 15px 45px rgba(0, 0, 0, 0.02);\n        }\n\n        .blog_section_b .help_callout_box h3 {\n            font-size: 32px;\n            font-weight: 700;\n            color: #ffffff;\n            margin-bottom: 12px;\n        }\n\n        body.light_theme .blog_section_b .help_callout_box h3 {\n            color: #0F172A;\n        }\n\n        .blog_section_b .help_callout_box p {\n            color: #94A3B8;\n            font-size: 16px;\n            max-width: 650px;\n        }\n\n        body.light_theme .blog_section_b .help_callout_box p {\n            color: #475569;\n        }\n\n        .blog_section_b .help_btn {\n            background: transparent;\n            border: 2px solid #D1AA67;\n            color: #D1AA67 !important;\n            font-weight: 600;\n            font-size: 14px;\n            text-transform: uppercase;\n            letter-spacing: 1px;\n            padding: 12px 32px;\n            border-radius: 50px;\n            transition: all 0.3s;\n            display: inline-block;\n            text-decoration: none;\n        }\n\n        body.light_theme .blog_section_b .help_btn {\n            border-color: #D1AA67;\n            color: #D1AA67 !important;\n        }\n\n        .blog_section_b .help_btn:hover {\n            background: #D1AA67;\n            color: #080A10 !important;\n            box-shadow: 0 5px 15px rgba(209, 170, 103, 0.3);\n            transform: translateY(-2px);\n        }\n\n        body.light_theme .blog_section_b .help_btn:hover {\n            background: #D1AA67;\n            color: #ffffff !important;\n            box-shadow: 0 5px 15px rgba(176, 130, 38, 0.3);\n            transform: translateY(-2px);\n        }\n\n        .blog_detail {\n            font-family: 'Inter', sans-serif;\n            color: #eaecd0;\n            background-color: #0b0e11;\n            padding-bottom: 80px;\n        }\n\n        body.light_theme .blog_detail {\n            color: #1e2329;\n            background-color: #f8fafe;\n        }\n\n        .blog_detail .inner-page-banner {\n            background: radial-gradient(circle at 10% 20%, rgba(24, 26, 32, 0.75) 0%, rgba(11, 14, 17, 0.95) 90%), var(--banner-bg) !important;\n            background-size: cover !important;\n            background-position: center !important;\n            padding: 80px 0 60px !important;\n            border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n            position: relative;\n        }\n\n        body.light_theme .blog_detail .inner-page-banner {\n            background: radial-gradient(circle at 10% 20%, rgba(244, 246, 250, 0.85) 0%, rgba(255, 255, 255, 0.97) 90%) !important;\n            border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n        }\n\n        .blog_detail .inner-page-banner .title {\n            font-size: 42px;\n            font-weight: 700;\n            background: linear-gradient(135deg, #ffffff 0%, #a2a6b0 100%);\n            -webkit-background-clip: text;\n            -webkit-text-fill-color: transparent;\n        }\n\n        body.light_theme .blog_detail .inner-page-banner .title {\n            background: linear-gradient(135deg, #1e2329 0%, #4a5568 100%);\n            -webkit-background-clip: text;\n            -webkit-text-fill-color: transparent;\n        }\n\n        .blog-details-wrapper .blog-content {\n            border-radius: 24px;\n            overflow: hidden;\n            border: 1px solid rgba(255, 255, 255, 0.05);\n            background: rgba(30, 32, 38, 0.45);\n            padding: 48px;\n            box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);\n            backdrop-filter: blur(5px);\n        }\n\n        body.light_theme .blog-details-wrapper .blog-content {\n            border: 1px solid rgba(0, 0, 0, 0.05);\n            background: #ffffff;\n            box-shadow: 0 12px 40px rgba(0, 0, 0, 0.03);\n        }\n\n        .blog_detail .single_blog_img {\n            border-radius: 16px;\n            overflow: hidden;\n            margin-bottom: 35px;\n            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n        }\n\n        .blog_detail .single_blog_img img {\n            width: 100%;\n            height: auto;\n            object-fit: cover;\n            max-height: 420px;\n        }\n\n        .blog_detail .blog-content h2 {\n            font-size: 34px;\n            font-weight: 700;\n            color: #ffffff;\n            line-height: 1.3;\n            margin-bottom: 24px;\n        }\n\n        body.light_theme .blog_detail .blog-content h2 {\n            color: #1e2329;\n        }\n\n        .blog_detail .blog-content p {\n            font-size: 16px;\n            line-height: 1.85;\n            color: #cccccc;\n            margin-bottom: 20px;\n            text-align: justify;\n        }\n\n        body.light_theme .blog_detail .blog-content p {\n            color: #474d57;\n        }\n\n        /* Sidebar styles */\n        .blog_detail .sidebar .single-widget {\n            border-radius: 24px;\n            border: 1px solid rgba(255, 255, 255, 0.05);\n            background: rgba(30, 32, 38, 0.45);\n            padding: 30px 24px;\n            box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);\n            backdrop-filter: blur(5px);\n        }\n\n        body.light_theme .blog_detail .sidebar .single-widget {\n            border: 1px solid rgba(0, 0, 0, 0.05);\n            background: #ffffff;\n            box-shadow: 0 12px 40px rgba(0, 0, 0, 0.03);\n        }\n\n        .blog_detail .sidebar .single-widget h3.title {\n            font-size: 20px;\n            font-weight: 700;\n            color: #D1AA67;\n            margin-bottom: 24px;\n            border-left: 4px solid #D1AA67;\n            padding-left: 12px;\n            text-transform: uppercase;\n            letter-spacing: 0.5px;\n        }\n\n        body.light_theme .blog_detail .sidebar .single-widget h3.title {\n            color: #b08226;\n            border-left-color: #b08226;\n        }\n\n        .blog_detail .sidebar .list_with_img li {\n            cursor: pointer;\n            transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n            border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n            padding: 15px 0;\n        }\n\n        body.light_theme .blog_detail .sidebar .list_with_img li {\n            border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n        }\n\n        .blog_detail .sidebar .list_with_img li:first-child {\n            padding-top: 0;\n        }\n\n        .blog_detail .sidebar .list_with_img li:last-child {\n            border-bottom: none;\n            padding-bottom: 0;\n        }\n\n        .blog_detail .sidebar .list_with_img li:hover {\n            transform: translateX(4px);\n        }\n\n        .blog_detail .sidebar .list_with_img li a {\n            color: #ffffff;\n            font-weight: 600;\n            line-height: 1.4;\n            font-size: 14px;\n            text-decoration: none;\n            transition: color 0.3s;\n        }\n\n        body.light_theme .blog_detail .sidebar .list_with_img li a {\n            color: #1e2329;\n        }\n\n        .blog_detail .sidebar .list_with_img li:hover a {\n            color: #D1AA67;\n        }\n\n        body.light_theme .blog_detail .sidebar .list_with_img li:hover a {\n            color: #b08226;\n        }\n\n        /* Back Link */\n        .blog_detail .back-link {\n            color: #848e9c !important;\n            font-weight: 600;\n            font-size: 14px;\n            text-decoration: none;\n            transition: all 0.3s;\n            display: inline-flex;\n            align-items: center;\n            gap: 8px;\n        }\n\n        .blog_detail .back-link:hover {\n            color: #D1AA67 !important;\n        }\n\n        body.light_theme .blog_detail .back-link:hover {\n            color: #b08226 !important;\n        }\n\n        .blog_detail .back-link .arrow {\n            transition: transform 0.3s;\n        }\n\n        .blog_detail .back-link:hover .arrow {\n            transform: translateX(-4px);\n        }\n\n        .subscribe_form.blog_news form {\n            width: 100%;\n        }\n\n\n\n\n\n\n\n\n\n\n\n        .blog-page {\n            font-family: 'Inter', 'Outfit', system-ui, -apple-system, sans-serif;\n            background-color: #FFFFFF;\n            color: #1A1C23;\n            padding: 40px 0 80px 0;\n        }\n\n        .blog-container {\n            max-width: 1480px;\n            margin: 0 auto;\n            padding: 0 20px;\n        }\n\n        /* --- Header Section --- */\n        .blog-header {\n            margin-bottom: 30px;\n        }\n\n        .blog-header h1 {\n            font-size: 40px;\n            font-weight: 700;\n            color: #111827;\n            margin: 0 0 10px 0;\n        }\n\n        .blog-header p {\n            font-size: 16px;\n            color: #9CA3AF;\n            margin: 0 0 24px 0;\n        }\n\n        .blog-categories {\n            display: flex;\n            margin-top: 10px;\n            gap: 10px;\n            flex-wrap: wrap;\n        }\n\n        .blog-cat-btn {\n            padding: 8px 18px;\n            border-radius: 20px;\n            font-size: 14px;\n            font-weight: 500;\n            color: #838383;\n            background-color: #F3F4F6;\n            border: none;\n            cursor: pointer;\n            transition: all 0.2s;\n        }\n\n        .blog-cat-btn.active {\n            background-color: #D1AA67;\n            color: #FFFFFF;\n            font-weight: 600;\n        }\n\n        /* --- Main Content Grid Layout --- */\n        .blog-content-layout {\n            display: flex;\n            gap: 30px;\n            margin-top: 10px;\n        }\n\n        .blog-main-column {\n            flex: 1 1 70%;\n        }\n\n        .blog-sidebar-column {\n            width: 320px;\n            flex-shrink: 0;\n        }\n\n        /* --- Featured Post --- */\n        .featured-post-card {\n            background: #FFFFFF;\n            border: 1px solid #F3F4F6;\n            border-radius: 16px;\n            overflow: hidden;\n            margin-bottom: 70px;\n            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);\n        }\n\n        .featured-img-container {\n            width: 100%;\n            aspect-ratio: 16 / 9;\n            overflow: hidden;\n            background: #080A10;\n        }\n\n        .featured-img-container img {\n            width: 100%;\n            height: 100%;\n            object-fit: cover;\n            display: block;\n        }\n\n        .blog-empty {\n            font-size: 15px;\n            color: #6B7280;\n            margin: 24px 0;\n        }\n\n        .blog-empty--sidebar {\n            margin: 0;\n            font-size: 13px;\n        }\n\n        .featured-post-body {\n            padding: 20px 24px;\n        }\n\n        .post-meta {\n            display: flex;\n            align-items: center;\n            gap: 15px;\n            font-size: 14px;\n            color: #9CA3AF;\n            margin-bottom: 12px;\n        }\n\n        .badge-tag {\n            color: #D1AA67;\n            font-weight: 600;\n            background: #FFFBEB;\n            padding: 2px 8px;\n            border-radius: 4px;\n        }\n\n        .featured-post-title {\n            font-size: 20px;\n            font-weight: 700;\n            color: #111827;\n            line-height: 1.4;\n            margin-bottom: 10px;\n        }\n\n        .featured-post-excerpt {\n            font-size: 14px;\n            color: #6B7280;\n            line-height: 1.6;\n            margin: 0;\n        }\n\n        /* --- Blog Posts Grid --- */\n        .posts-grid {\n            display: grid;\n            grid-template-columns: repeat(3, 1fr);\n            gap: 20px;\n        }\n\n        .post-card {\n            background: #FFFFFF;\n            border: 1px solid #F3F4F6;\n            border-radius: 18px;\n            overflow: hidden;\n            display: flex;\n            flex-direction: column;\n            box-shadow: 0 2px 10px rgb(0 0 0 / 8%);\n            transition: transform 0.2s, box-shadow 0.2s;\n        }\n\n        .post-card:hover {\n            transform: translateY(-3px);\n            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.06);\n        }\n\n        .post-card-img {\n            width: 100%;\n            height: 160px;\n            object-fit: cover;\n        }\n\n        .post-card-body {\n            padding: 16px;\n            display: flex;\n            flex-direction: column;\n            flex: 1;\n        }\n\n        .post-card-title {\n            font-size: 16px;\n            font-weight: 700;\n            color: #111827;\n            line-height: 1.4;\n            margin: 8px 0;\n            display: -webkit-box;\n            -webkit-line-clamp: 2;\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n        }\n\n        .post-card-desc {\n            font-size: 14px;\n            color: #6B7280;\n            line-height: 1.5;\n            margin-bottom: 16px;\n            display: -webkit-box;\n            -webkit-line-clamp: 3;\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n            flex: 1;\n        }\n\n        .post-card-footer {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            font-size: 14px;\n            color: #9CA3AF;\n            border-top: 1px solid #FAFAFA;\n            padding-top: 12px;\n        }\n\n        .read-more-link {\n            color: #D3B06C;\n            font-weight: 600;\n            text-decoration: none;\n            transition: all 0.2s;\n        }\n\n        .read-more-link:hover {\n            color: #cca860;\n        }\n\n        /* --- Sidebar (Hot & Trending) --- */\n        .sidebar-card {\n            background: #FFFFFF;\n            border: 1px solid #F3F4F6;\n            border-radius: 16px;\n            padding: 24px 20px;\n            box-shadow: 0 2px 10px rgb(0 0 0 / 5%);\n        }\n\n        .sidebar-title {\n            font-size: 16px;\n            font-weight: 700;\n            color: #111827;\n            margin: 0 0 20px 0;\n        }\n\n        .trending-list {\n            display: flex;\n            flex-direction: column;\n            gap: 18px;\n        }\n\n        .trending-item {\n            display: flex;\n            align-items: flex-start;\n            gap: 12px;\n        }\n\n        .trending-num {\n            width: 24px;\n            height: 24px;\n            border-radius: 50%;\n            background: #D3B06C;\n            color: #FFFFFF;\n            font-size: 12px;\n            font-weight: 700;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            flex-shrink: 0;\n            margin-top: 2px;\n        }\n\n        .trending-info {\n            flex: 1;\n        }\n\n        .trending-headline {\n            font-size: 14px;\n            font-weight: 600;\n            color: #111827;\n            line-height: 1.4;\n            margin: 0 0 4px 0;\n            display: -webkit-box;\n            -webkit-line-clamp: 2;\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n            cursor: pointer;\n        }\n\n        .trending-headline:hover {\n            color: #D3B06C;\n        }\n\n        .trending-date {\n            font-size: 11px;\n            color: #9CA3AF;\n        }\n\n        /* --- Pagination --- */\n        .blog-pagination {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            gap: 8px;\n            margin-top: 40px;\n        }\n\n        .page-btn {\n            width: 32px;\n            height: 32px;\n            border-radius: 8px;\n            border: 1px solid #F3F4F6;\n            background: #FFFFFF;\n            color: #6B7280;\n            font-size: 13px;\n            font-weight: 600;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            cursor: pointer;\n            transition: all 0.2s;\n        }\n\n        .page-btn.active {\n            background: #D3B06C;\n            color: #FFFFFF;\n            border-color: #D3B06C;\n        }\n\n        .page-btn:hover:not(.active):not(:disabled) {\n            background: #F9FAFB;\n        }\n\n        .page-btn:disabled {\n            opacity: 0.4;\n            cursor: not-allowed;\n        }\n\n        @media (max-width: 1500px) {\n\n            .blog-container {\n                max-width: 95%;\n            }\n\n        }\n\n\n        @media (max-width: 1200px) {\n\n            .blog-header h1 {\n                font-size: 32px;\n            }\n\n            .posts-grid {\n                grid-template-columns: repeat(2, 1fr);\n            }\n\n        }\n\n\n        /* --- Responsive Adjustments --- */\n        @media (max-width: 992px) {\n\n            .blog-content-layout {\n                flex-direction: column;\n            }\n\n            .blog-header h1 {\n                font-size: 26px;\n            }\n\n            .blog-sidebar-column {\n                width: 100%;\n            }\n\n            .posts-grid {\n                grid-template-columns: repeat(2, 1fr);\n            }\n        }\n\n        @media (max-width: 600px) {\n\n            .blog-header h1 {\n                font-size: 24px;\n            }\n\n            .posts-grid {\n                grid-template-columns: 1fr;\n            }\n\n\n            .blog-header p {\n                font-size: 14px;\n                margin: 0 0 18px 0;\n            }\n\n            .blog-cat-btn {\n                padding: 6px 15px;\n                font-size: 13px;\n            }\n\n            .post-meta {\n                gap: 10px;\n                font-size: 12px;\n            }\n\n            .featured-post-body {\n                padding: 20px;\n            }\n\n            .featured-post-title {\n                font-size: 18px;\n            }\n\n            .featured-post-card {\n                margin-bottom: 30px;\n            }\n\n\n        }\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n        @media (max-width:1440px) {\n\n            .blog_section_b .hero_title {\n                font-size: 48px;\n            }\n        }\n\n        @media (max-width:1200px) {\n\n            .blog_section_b .hero_title {\n                font-size: 38px;\n            }\n\n            .blog_detail_page .container.blog_detail_container {\n                width: 95%;\n            }\n\n            .blog_section_b .hero_desc {\n                font-size: 16px;\n                width: 90%;\n            }\n\n            .blog_section_b .featured_title {\n                font-size: 26px;\n            }\n\n            .subscribe_form h4 {\n                font-size: 26px;\n            }\n\n            .blog_section_b .help_callout_box h3 {\n                font-size: 26px;\n            }\n\n            .blog_section_b .hero_container {\n                padding: 60px 0 40px;\n            }\n\n            .blog_section_b .subscribe_form {\n                padding: 24px 30px;\n            }\n\n\n        }\n\n\n        /* Responsiveness */\n        @media (max-width: 991px) {\n\n            .blog-details-wrapper .blog-content {\n                padding: 32px;\n            }\n\n            .blog_detail .inner-page-banner .title {\n                font-size: 30px;\n            }\n\n            .blog_detail .inner-page-banner {\n                padding: 40px 0 20px !important;\n            }\n\n            .subscribe_form h4 {\n                font-size: 22px;\n            }\n\n            .blog_section_b .hero_title {\n                font-size: 30px;\n            }\n\n            .blog_section_b .featured_split {\n                flex-direction: column;\n                gap: 30px;\n            }\n\n            .blog_section_b .featured_img_wrapper {\n                width: 100%;\n                height: 260px;\n            }\n\n            .blog_section_b .help_callout_box {\n                padding: 40px;\n                text-align: center;\n            }\n\n            .blog_section_b .help_callout_box p {\n                margin: 10px auto 25px;\n            }\n\n            .blog_detail .blog-content h2 {\n                font-size: 24px;\n            }\n\n            .single-widget.recent-post.mt-5 {\n                margin-top: 24px !important;\n            }\n\n        }\n\n        @media (max-width: 767px) {\n\n\n            .blog_detail_title {\n                font-size: 20px;\n            }\n\n            .blog_detail .inner-page-banner {\n                padding: 20px 0 20px !important;\n            }\n\n            .blog-container {\n                max-width: 100%;\n            }\n\n            .blog_detail .inner-page-banner .title {\n                font-size: 22px;\n            }\n\n            .blog_section_b .hero_container {\n                padding: 24px 0 20px;\n                text-align: center;\n            }\n\n            ol.breadcrumb {\n                font-size: 12px;\n            }\n\n            .blog-details-wrapper .blog-content {\n                padding: 20px;\n            }\n\n            .blog_detail .sidebar .single-widget h3.title {\n                font-size: 18px;\n            }\n\n            .blog_detail .sidebar .list_with_img li {\n                margin: 0px !important;\n            }\n\n            .blog_section_b .hero_title {\n                font-size: 24px;\n            }\n\n            .blog_section_b .hero_desc {\n                font-size: 15px;\n                width: 100%;\n                margin-bottom: 20px;\n            }\n\n            .blog_section_b .tab_dock_wrapper {\n                margin-top: 20px;\n                margin-bottom: 20px;\n            }\n\n            .blog_section_b .category_dock_item {\n                padding: 8px 12px;\n                font-size: 12px;\n            }\n\n            .blog_section_b .top_right_img img {\n                max-width: 310px;\n            }\n\n            .top_right_img {\n                max-width: 310px;\n                margin: 0 auto;\n            }\n\n            .blog_section_b .featured_card {\n                padding: 24px;\n                margin-bottom: 30px;\n            }\n\n            .blog_section_b .grid_section_title {\n                font-size: 22px;\n            }\n\n            .blog_section_b .help_callout_box {\n                padding: 24px;\n                margin-top: 40px;\n            }\n\n            .blog_section_b .help_callout_box p {\n                font-size: 14px;\n            }\n\n            .blog_section_b .help_btn {\n                font-size: 12px;\n                padding: 8px 32px;\n            }\n\n            .blog_detail .blog-content h2 {\n                font-size: 20px;\n            }\n\n            .blog_detail .blog-content p {\n                font-size: 14px;\n            }\n\n        }\n\n        @media (max-width:580px) {\n\n            .blog_section_b .search_input_wrap {\n                min-width: 100%;\n            }\n\n            .blog_section_b .featured_title {\n                font-size: 20px;\n            }\n\n            .blog_section_b .featured_meta {\n                gap: 10px;\n            }\n\n            .blog_section_b .featured_excerpt {\n                font-size: 14px;\n                margin-bottom: 18px;\n            }\n\n            .blog_section_b .blog_cards_grid {\n                gap: 22px;\n            }\n\n            .blog_section_b .subscribe_form {\n                margin-top: 30px;\n            }\n\n\n            .blog_section_b .category_dock_item {\n                padding: 5px 9px;\n                font-size: 12px;\n                white-space: nowrap;\n            }\n\n            .blog_section_b .read_more_action {\n                font-size: 13px;\n            }\n\n            .blog_section_b .grid_section_title {\n                font-size: 20px;\n            }\n\n            .blog_section_b .grid_section_header {\n                margin-bottom: 20px;\n            }\n\n            .blog_section_b .blog_cards_grid {\n                grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));\n            }\n\n            .blog_section_b .modern_blog_card {\n                border-radius: 20px;\n                padding: 18px;\n            }\n\n            .subscribe_form h4 {\n                font-size: 18px;\n            }\n\n            .blog_section_b .subscribe_form {\n                padding: 20px;\n            }\n\n            .blog_section_b .subscribe-input {\n                font-size: 12px !important;\n                padding: 10px 16px !important;\n            }\n\n            .blog_section_b .startbtn {\n                padding: 10px 22px;\n            }\n\n            .subscribe_form form {\n                margin-top: 5px;\n            }\n\n            .blog_section_b .help_callout_box h3 {\n                font-size: 22px;\n            }\n\n            .blog_section_b .search_input_wrap input {\n                padding: 10px 22px 10px 38px;\n                font-size: 12px;\n            }\n\n\n        }\n\n        /* ==========================================================================\n   BLOG DETAILS PAGE STYLES (Matching Screenshot input_file_0.png - Light Theme Default)\n   ========================================================================== */\n\n        .blog_detail_page {\n            font-family: 'Inter', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n            background-color: #FFFFFF;\n            color: #0F172A;\n            padding: 40px 0 100px;\n            min-height: 100vh;\n        }\n\n        body:not(.light_theme) .blog_detail_page {\n            background-color: #181a20;\n            color: #E2E8F0;\n        }\n\n        .blog_detail_container {\n            max-width: 1280px;\n            margin: 0 auto;\n            padding: 0 20px;\n        }\n\n        .blog_detail_back {\n            display: inline-flex;\n            align-items: center;\n            gap: 8px;\n            margin: 0 0 20px;\n            color: #848e9c;\n            font-size: 14px;\n            font-weight: 600;\n            text-decoration: none;\n            transition: color 0.25s ease;\n        }\n\n        .blog_detail_back:hover {\n            color: #D1AA67;\n        }\n\n        body.light_theme .blog_detail_back {\n            color: #64748b;\n        }\n\n        body.light_theme .blog_detail_back:hover {\n            color: #b08226;\n        }\n\n        .blog_detail_back_arrow {\n            display: inline-block;\n            transition: transform 0.25s ease;\n        }\n\n        .blog_detail_back:hover .blog_detail_back_arrow {\n            transform: translateX(-4px);\n        }\n\n        /* Category Tags */\n        .blog_detail_tags {\n            display: flex;\n            flex-wrap: wrap;\n            gap: 8px;\n            margin-bottom: 16px;\n        }\n\n        .blog_tag_pill {\n            display: inline-block;\n            font-size: 12px;\n            font-weight: 600;\n            color: #E11D48;\n            background: #FFF0F0;\n            padding: 4px 12px;\n            border-radius: 6px;\n        }\n\n        body:not(.light_theme) .blog_tag_pill {\n            color: #E11D48;\n            background: rgba(225, 29, 72, 0.12);\n        }\n\n        /* Main Article Title */\n        .blog_detail_title {\n            font-size: 30px;\n            font-weight: 700;\n            line-height: 1.25;\n            color: #0F172A;\n            margin-bottom: 16px;\n            letter-spacing: -0.5px;\n        }\n\n        body:not(.light_theme) .blog_detail_title {\n            color: #FFFFFF;\n        }\n\n        /* Subtitle / Excerpt */\n        .blog_detail_subtitle {\n            font-size: 16px;\n            line-height: 1.6;\n            color: #64748B;\n            margin-bottom: 24px;\n        }\n\n        body:not(.light_theme) .blog_detail_subtitle {\n            color: #94A3B8;\n        }\n\n        /* Hero Image */\n        .blog_detail_hero_img_wrap {\n            width: 100%;\n            aspect-ratio: 16 / 9;\n            overflow: hidden;\n            margin-bottom: 24px;\n            background: #080A10;\n            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);\n        }\n\n        .blog_detail_hero_img {\n            width: 100%;\n            height: 100%;\n            aspect-ratio: 16 / 9;\n            object-fit: cover;\n            display: block;\n            border: 5px solid rgb(246 246 246 / 30%);\n        }\n\n        body.light_theme .blog_detail_hero_img {\n            border: 5px solid rgb(255 255 255 / 60%);\n        }\n\n        .blog_detail_layout .blog-prose p {\n            font-size: 16px;\n            color: #6B7280;\n            margin-bottom: 12px !important;\n        }\n\n        .blog_detail_layout .blog-prose ul {\n            list-style: disc;\n        }\n\n        .blog_detail_layout .blog-prose a {\n            color: #d1aa67;\n        }\n\n        /* Author & Meta Bar */\n        .blog_detail_author_meta {\n            display: flex;\n            align-items: center;\n            gap: 12px;\n            margin-bottom: 32px;\n        }\n\n        .blog_detail_author_meta .author_avatar {\n            width: 32px;\n            height: 32px;\n            border-radius: 50%;\n            background: #F59E0B;\n            color: #FFFFFF;\n            font-weight: 700;\n            font-size: 14px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            flex-shrink: 0;\n            overflow: hidden;\n        }\n\n        .blog_detail_author_meta .author_avatar img {\n            width: 100%;\n            height: 100%;\n            object-fit: cover;\n        }\n\n        .blog-prose {\n            font-size: 15px;\n            line-height: 1.7;\n            color: #475569;\n        }\n\n        body:not(.light_theme) .blog-prose {\n            color: #94A3B8;\n        }\n\n        .blog-prose h1,\n        .blog-prose h2,\n        .blog-prose h3,\n        .blog-prose h4,\n        .blog-prose h5,\n        .blog-prose h6 {\n            font-weight: 700;\n            color: #0F172A;\n            margin-top: 36px;\n            margin-bottom: 16px;\n            scroll-margin-top: 100px;\n        }\n\n        .blog-prose h1 {\n            font-size: 28px;\n        }\n\n        .blog-prose h2 {\n            font-size: 22px;\n        }\n\n        .blog-prose h3 {\n            font-size: 18px;\n        }\n\n        .blog-prose h4 {\n            font-size: 16px;\n        }\n\n        .blog-prose h5,\n        .blog-prose h6 {\n            font-size: 15px;\n        }\n\n        body:not(.light_theme) .blog-prose h1,\n        body:not(.light_theme) .blog-prose h2,\n        body:not(.light_theme) .blog-prose h3,\n        body:not(.light_theme) .blog-prose h4,\n        body:not(.light_theme) .blog-prose h5,\n        body:not(.light_theme) .blog-prose h6 {\n            color: #F8FAFC;\n        }\n\n        .blog-prose p {\n            margin-bottom: 18px;\n        }\n\n        .blog-prose span[style*=\"font-size\"] {\n            line-height: 1.45;\n        }\n\n        .blog-prose a {\n            color: #D3B06C;\n            font-weight: 600;\n        }\n\n        .blog-prose i[class*=\"fa\"] {\n            font-style: normal;\n        }\n\n        .blog-prose mark {\n            background: #fef08a;\n            padding: 0 0.15em;\n        }\n\n        .blog-prose img {\n            max-width: 100%;\n            height: auto;\n            border-radius: 8px;\n        }\n\n        .blog-prose h1,\n        .blog-prose h2,\n        .blog-prose h3,\n        .blog-prose h4,\n        .blog-prose h5,\n        .blog-prose h6 {\n            overflow: visible;\n            line-height: 1.4;\n            max-width: 100%;\n        }\n\n        .blog-prose div,\n        .blog-prose .blog-box {\n            overflow: visible;\n            max-width: 100%;\n            box-sizing: border-box;\n        }\n\n        .blog-prose table {\n            width: 100%;\n            max-width: 100%;\n            border-collapse: collapse;\n            margin: 0 0 18px;\n        }\n\n        .blog-prose th,\n        .blog-prose td {\n            border: 1px solid #E2E8F0;\n            padding: 8px 10px;\n            vertical-align: top;\n            word-break: break-word;\n        }\n\n        .blog-prose ul,\n        .blog-prose ol {\n            margin: 0 0 18px 1.2em;\n        }\n\n        .blog-prose li {\n            margin-bottom: 8px;\n        }\n\n        .blog_detail_author_meta .author_info {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            font-size: 13px;\n        }\n\n        .blog_detail_author_meta .author_name {\n            font-weight: 600;\n            color: #334155;\n        }\n\n        body:not(.light_theme) .blog_detail_author_meta .author_name {\n            color: #E2E8F0;\n        }\n\n        .blog_detail_author_meta .meta_dot {\n            color: #94A3B8;\n        }\n\n        .blog_detail_author_meta .meta_time_date {\n            color: #64748B;\n        }\n\n        body:not(.light_theme) .blog_detail_author_meta .meta_time_date {\n            color: #94A3B8;\n        }\n\n        /* Security Alert Box */\n        .blog_alert_box {\n            background: #FFF7ED;\n            border: 1px solid #FED7AA;\n            border-radius: 10px;\n            padding: 16px 20px;\n            display: flex;\n            align-items: flex-start;\n            gap: 12px;\n            margin-bottom: 32px;\n        }\n\n        body:not(.light_theme) .blog_alert_box {\n            background: rgba(234, 88, 12, 0.12);\n            border-color: rgba(234, 88, 12, 0.3);\n        }\n\n        .blog_alert_box .alert_icon {\n            font-size: 18px;\n            flex-shrink: 0;\n        }\n\n        .blog_alert_box .alert_content {\n            font-size: 14px;\n            line-height: 1.5;\n            color: #C2410C;\n        }\n\n        body:not(.light_theme) .blog_alert_box .alert_content {\n            color: #FDBA74;\n        }\n\n        /* Key Takeaway Box */\n        .blog_takeaways_card {\n            background: #F8FAFC;\n            border: 1px solid #E2E8F0;\n            border-radius: 12px;\n            padding: 24px;\n            margin-bottom: 36px;\n        }\n\n        body:not(.light_theme) .blog_takeaways_card {\n            background: #ffffff08;\n            border-color: rgba(255, 255, 255, 0.08);\n        }\n\n        .blog_takeaways_card .takeaways_title {\n            font-size: 16px;\n            font-weight: 700;\n            color: #0F172A;\n            margin-bottom: 16px;\n        }\n\n        body:not(.light_theme) .blog_takeaways_card .takeaways_title {\n            color: #FFFFFF;\n        }\n\n        .blog_takeaways_card .takeaways_list {\n            list-style: none;\n            padding: 0;\n            margin: 0;\n            display: flex;\n            flex-direction: column;\n            gap: 12px;\n        }\n\n        .blog_takeaways_card .takeaways_list li {\n            display: flex;\n            align-items: flex-start;\n            gap: 8px;\n            font-size: 14px;\n            line-height: 1.5;\n            color: #334155;\n        }\n\n        body:not(.light_theme) .blog_takeaways_card .takeaways_list li {\n            color: #CBD5E1;\n        }\n\n        .blog_takeaways_card .list_num {\n            font-weight: 700;\n            color: #D97706;\n            flex-shrink: 0;\n        }\n\n        /* Section Block */\n        .blog_section_block {\n            margin-bottom: 36px;\n        }\n\n        .blog_section_block .section_heading {\n            font-size: 18px;\n            font-weight: 700;\n            color: #0F172A;\n            margin-top: 36px;\n            margin-bottom: 16px;\n        }\n\n        body:not(.light_theme) .blog_section_block .section_heading {\n            color: #F8FAFC;\n        }\n\n        .blog_section_block .section_p {\n            font-size: 15px;\n            line-height: 1.7;\n            color: #475569;\n            margin-bottom: 18px;\n        }\n\n        body:not(.light_theme) .blog_section_block .section_p {\n            color: #94A3B8;\n        }\n\n        /* Badge Numbered List */\n        .badge_numbered_list {\n            list-style: none;\n            padding: 0;\n            margin: 20px 0;\n            display: flex;\n            flex-direction: column;\n            gap: 14px;\n        }\n\n        .badge_numbered_list li {\n            display: flex;\n            align-items: flex-start;\n            gap: 12px;\n        }\n\n        .badge_numbered_list .badge_circle_num {\n            width: 26px;\n            height: 26px;\n            border-radius: 50%;\n            background: #FFEDD5;\n            color: #D97706;\n            font-size: 13px;\n            font-weight: 700;\n            display: inline-flex;\n            align-items: center;\n            justify-content: center;\n            flex-shrink: 0;\n        }\n\n        body:not(.light_theme) .badge_numbered_list .badge_circle_num {\n            background: rgba(217, 119, 6, 0.2);\n            color: #F59E0B;\n        }\n\n        .badge_numbered_list .badge_list_text {\n            font-size: 14px;\n            line-height: 1.6;\n            color: #334155;\n            margin-top: 2px;\n        }\n\n        body:not(.light_theme) .badge_numbered_list .badge_list_text {\n            color: #CBD5E1;\n        }\n\n        /* Impact Stats Grid */\n        .impact_stats_grid {\n            display: grid;\n            grid-template-columns: 1fr 1fr;\n            gap: 20px;\n            margin: 24px 0 36px;\n        }\n\n        .impact_stat_card {\n            border-radius: 12px;\n            padding: 24px;\n            text-align: center;\n        }\n\n        .impact_stat_card.danger {\n            background: #FEF2F2;\n            border: 1px solid #FEE2E2;\n        }\n\n        body:not(.light_theme) .impact_stat_card.danger {\n            background: rgba(239, 68, 68, 0.1);\n            border-color: rgba(239, 68, 68, 0.2);\n        }\n\n        .impact_stat_card.danger .stat_icon {\n            color: #EF4444;\n        }\n\n        .impact_stat_card.danger .stat_val {\n            color: #EF4444;\n        }\n\n        .impact_stat_card.danger .stat_label {\n            color: #DC2626;\n        }\n\n        body:not(.light_theme) .impact_stat_card.danger .stat_label {\n            color: #F87171;\n        }\n\n        .impact_stat_card.warning {\n            background: #FFF7ED;\n            border: 1px solid #FFEDD5;\n        }\n\n        body:not(.light_theme) .impact_stat_card.warning {\n            background: rgba(249, 115, 22, 0.1);\n            border-color: rgba(249, 115, 22, 0.2);\n        }\n\n        .impact_stat_card.warning .stat_icon {\n            color: #F97316;\n        }\n\n        .impact_stat_card.warning .stat_val {\n            color: #F97316;\n        }\n\n        .impact_stat_card.warning .stat_label {\n            color: #EA580C;\n        }\n\n        body:not(.light_theme) .impact_stat_card.warning .stat_label {\n            color: #FB923C;\n        }\n\n        .impact_stat_card .stat_icon {\n            font-size: 24px;\n            margin-bottom: 8px;\n        }\n\n        .impact_stat_card .stat_val {\n            font-size: 32px;\n            font-weight: 800;\n            line-height: 1.1;\n            margin-bottom: 6px;\n        }\n\n        .impact_stat_card .stat_label {\n            font-size: 13px;\n            font-weight: 600;\n            text-transform: uppercase;\n            letter-spacing: 0.5px;\n        }\n\n        /* Checkmark List */\n        .checkmark_list {\n            list-style: none;\n            padding: 0;\n            margin: 20px 0;\n            display: flex;\n            flex-direction: column;\n            gap: 12px;\n        }\n\n        .checkmark_list li {\n            display: flex;\n            align-items: flex-start;\n            gap: 10px;\n        }\n\n        .checkmark_list .check_icon {\n            color: #10B981;\n            font-size: 16px;\n            font-weight: 700;\n            flex-shrink: 0;\n            margin-top: 2px;\n        }\n\n        .checkmark_list .check_text {\n            font-size: 14px;\n            line-height: 1.6;\n            color: #334155;\n        }\n\n        body:not(.light_theme) .checkmark_list .check_text {\n            color: #CBD5E1;\n        }\n\n        /* Open sidebar (mock: agcx-blog-sidebar-v2) */\n        .blog_detail_layout {\n            display: grid;\n            grid-template-columns: 1fr;\n            gap: 28px;\n            align-items: start;\n            min-width: 0;\n        }\n\n        .blog_detail_main,\n        .blog_detail_sidebar {\n            min-width: 0;\n        }\n\n        .blog_aside {\n            border-left: none;\n            padding-left: 0;\n            padding-right: 6px;\n            display: flex;\n            flex-direction: column;\n            background: #ffffff;\n            scrollbar-width: thin;\n            scrollbar-color: transparent transparent;\n            transition: scrollbar-color 0.2s ease;\n        }\n\n        .blog_aside:hover,\n        .blog_aside:focus-within {\n            scrollbar-color: rgba(15, 23, 42, 0.2) transparent;\n        }\n\n        .blog_aside::-webkit-scrollbar {\n            width: 5px;\n            height: 5px;\n        }\n\n        .blog_aside::-webkit-scrollbar-track {\n            background: transparent;\n        }\n\n        .blog_aside::-webkit-scrollbar-thumb {\n            background: transparent;\n            border-radius: 10px;\n            transition: background-color 0.2s ease;\n        }\n\n        .blog_aside:hover::-webkit-scrollbar-thumb,\n        .blog_aside:focus-within::-webkit-scrollbar-thumb {\n            background: rgba(15, 23, 42, 0.2);\n        }\n\n        .blog_aside:hover::-webkit-scrollbar-thumb:hover {\n            background: rgba(15, 23, 42, 0.35);\n        }\n\n        body:not(.light_theme) .blog_aside,\n        html[data-theme=\"dark\"] .blog_aside,\n        body.dark-mode .blog_aside {\n            background: #181a20;\n            scrollbar-color: transparent transparent;\n        }\n\n        body:not(.light_theme) .blog_aside:hover,\n        body:not(.light_theme) .blog_aside:focus-within,\n        html[data-theme=\"dark\"] .blog_aside:hover,\n        html[data-theme=\"dark\"] .blog_aside:focus-within,\n        body.dark-mode .blog_aside:hover,\n        body.dark-mode .blog_aside:focus-within {\n            scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n        }\n\n        body:not(.light_theme) .blog_aside:hover::-webkit-scrollbar-thumb,\n        body:not(.light_theme) .blog_aside:focus-within::-webkit-scrollbar-thumb,\n        html[data-theme=\"dark\"] .blog_aside:hover::-webkit-scrollbar-thumb,\n        html[data-theme=\"dark\"] .blog_aside:focus-within::-webkit-scrollbar-thumb,\n        body.dark-mode .blog_aside:hover::-webkit-scrollbar-thumb,\n        body.dark-mode .blog_aside:focus-within::-webkit-scrollbar-thumb {\n            background: rgba(255, 255, 255, 0.2);\n        }\n\n        body:not(.light_theme) .blog_aside:hover::-webkit-scrollbar-thumb:hover,\n        html[data-theme=\"dark\"] .blog_aside:hover::-webkit-scrollbar-thumb:hover,\n        body.dark-mode .blog_aside:hover::-webkit-scrollbar-thumb:hover {\n            background: rgba(255, 255, 255, 0.35);\n        }\n\n        body:not(.light_theme) .blog_aside {\n            border-left-color: rgba(255, 255, 255, 0.08);\n        }\n\n        .blog_aside_sec {\n            padding: 22px;\n            border: 1px solid #3b3b3b;\n            border-radius: 18px;\n        }\n\n        body.light_theme .blog_aside_sec {\n            border: 1px solid #F3F4F6;\n        }\n\n        .blog_aside_sec+.blog_aside_sec {\n            border-top: 1px solid rgba(15, 23, 42, 0.1);\n            padding-top: 28px;\n        }\n\n        body:not(.light_theme) .blog_aside_sec+.blog_aside_sec {\n            border-top-color: rgba(255, 255, 255, 0.08);\n        }\n\n        .blog_aside_head {\n            display: flex;\n            align-items: baseline;\n            justify-content: space-between;\n            margin-bottom: 16px;\n        }\n\n        .blog_aside_head h3 {\n            font-size: 15.5px;\n            font-weight: 600;\n            letter-spacing: 0.01em;\n            margin: 0;\n            display: flex;\n            align-items: center;\n            gap: 9px;\n            color: #0F172A;\n        }\n\n        body:not(.light_theme) .blog_aside_head h3 {\n            color: #f2f2f4;\n        }\n\n        .blog_aside_head h3::before {\n            content: \"\";\n            width: 16px;\n            height: 2px;\n            border-radius: 2px;\n            background: linear-gradient(135deg, #e8c878 0%, #c69a3f 55%, #a87f2c 100%);\n        }\n\n        .blog_aside_meta {\n            font-size: 12px;\n            color: #6c6c75;\n        }\n\n        .blog_aside_copy {\n            display: inline-flex;\n            align-items: center;\n            gap: 9px;\n            height: 40px;\n            padding: 0 18px;\n            border-radius: 20px;\n            border: 1px solid rgba(15, 23, 42, 0.12);\n            background: transparent;\n            font-size: 13px;\n            font-weight: 600;\n            color: #6B7280;\n            cursor: pointer;\n            transition: color 0.18s, border-color 0.18s, background 0.18s;\n        }\n\n        body:not(.light_theme) .blog_aside_copy {\n            border-color: rgba(255, 255, 255, 0.08);\n            color: #9a9aa3;\n        }\n\n        .blog_aside_copy svg {\n            width: 15px;\n            height: 15px;\n            stroke: currentColor;\n            fill: none;\n            stroke-width: 2;\n        }\n\n        .blog_aside_copy:hover,\n        .blog_aside_copy.is-copied {\n            color: #d4a94e;\n            border-color: rgba(212, 169, 78, 0.45);\n            background: rgba(212, 169, 78, 0.12);\n        }\n\n        .blog_aside_toc {\n            list-style: none;\n            position: relative;\n            padding: 0;\n            margin: 0;\n        }\n\n        .blog_aside_toc::before {\n            content: \"\";\n            position: absolute;\n            left: 0;\n            top: 6px;\n            bottom: 6px;\n            width: 1px;\n            background: rgba(15, 23, 42, 0.1);\n        }\n\n        body:not(.light_theme) .blog_aside_toc::before {\n            background: rgba(255, 255, 255, 0.08);\n        }\n\n        .blog_aside_toc button {\n            display: block;\n            position: relative;\n            width: 100%;\n            padding: 7px 0 7px 18px;\n            font-size: 13.5px;\n            line-height: 1.45;\n            color: #6B7280;\n            background: none;\n            border: none;\n            text-align: left;\n            cursor: pointer;\n            transition: color 0.15s;\n        }\n\n        body:not(.light_theme) .blog_aside_toc button {\n            color: #9a9aa3;\n        }\n\n        .blog_aside_toc button::before {\n            content: \"\";\n            position: absolute;\n            left: -1px;\n            top: 6px;\n            bottom: 6px;\n            width: 2px;\n            background: transparent;\n            border-radius: 2px;\n        }\n\n        .blog_aside_toc button:hover {\n            color: #0F172A;\n        }\n\n        body:not(.light_theme) .blog_aside_toc button:hover {\n            color: #f2f2f4;\n        }\n\n        .blog_aside_toc button.is-active {\n            color: #d4a94e;\n            font-weight: 500;\n        }\n\n        .blog_aside_toc button.is-active::before {\n            background: #d4a94e;\n        }\n\n        .blog_aside_rel {\n            display: flex;\n            gap: 14px;\n            padding: 10px 0;\n            text-decoration: none;\n            color: inherit;\n        }\n\n        .blog_aside_rel_thumb {\n            width: 66px;\n            height: 66px;\n            flex-shrink: 0;\n            border-radius: 12px;\n            background: radial-gradient(120% 120% at 20% 0%, rgba(212, 169, 78, 0.16), rgba(15, 23, 42, 0.04) 60%);\n            border: 1px solid rgba(15, 23, 42, 0.1);\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            overflow: hidden;\n            transition: border-color 0.15s;\n        }\n\n        body:not(.light_theme) .blog_aside_rel_thumb {\n            background: radial-gradient(120% 120% at 20% 0%, rgba(212, 169, 78, 0.16), rgba(255, 255, 255, 0.02) 60%);\n            border-color: rgba(255, 255, 255, 0.08);\n        }\n\n        .blog_aside_rel:hover .blog_aside_rel_thumb {\n            border-color: rgba(212, 169, 78, 0.4);\n        }\n\n        .blog_aside_rel_thumb svg {\n            width: 26px;\n            height: 26px;\n        }\n\n        .blog_aside_rel_thumb img {\n            width: 100%;\n            height: 100%;\n            object-fit: cover;\n        }\n\n        .blog_aside_rel_body {\n            min-width: 0;\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            gap: 5px;\n        }\n\n        .blog_aside_rel_kicker {\n            font-size: 11.5px;\n            color: #d4a94e;\n            font-weight: 600;\n        }\n\n        .blog_aside_rel_title {\n            font-size: 13.5px;\n            font-weight: 600;\n            line-height: 1.4;\n            color: #0F172A;\n            display: -webkit-box;\n            -webkit-line-clamp: 2;\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n            transition: color 0.15s;\n        }\n\n        body:not(.light_theme) .blog_aside_rel_title {\n            color: #f2f2f4;\n        }\n\n        .blog_aside_rel:hover .blog_aside_rel_title {\n            color: #d4a94e;\n        }\n\n        .blog_aside_rel_meta {\n            font-size: 12px;\n            color: #6c6c75;\n        }\n\n        .blog_aside_viewall {\n            display: inline-flex;\n            align-items: center;\n            gap: 7px;\n            margin-top: 10px;\n            font-size: 13px;\n            font-weight: 600;\n            color: #6B7280;\n            text-decoration: none;\n            transition: color 0.15s;\n        }\n\n        body:not(.light_theme) .blog_aside_viewall {\n            color: #9a9aa3;\n        }\n\n        .blog_aside_viewall:hover {\n            color: #d4a94e;\n        }\n\n        .blog_aside_viewall svg {\n            width: 13px;\n            height: 13px;\n            stroke: currentColor;\n            fill: none;\n            stroke-width: 2.2;\n        }\n\n        .blog_aside_cta {\n            margin-top: 2px;\n            border-radius: 16px;\n            padding: 1px;\n            background: linear-gradient(150deg, rgba(198, 154, 63, 0.55), rgba(212, 169, 78, 0.12) 45%, rgba(15, 23, 42, 0.06));\n        }\n\n        body:not(.light_theme) .blog_aside_cta {\n            background: linear-gradient(150deg, rgba(232, 200, 120, 0.55), rgba(212, 169, 78, 0.12) 45%, rgba(255, 255, 255, 0.05));\n        }\n\n        .blog_aside_cta_inner {\n            border-radius: 15px;\n            background:\n                radial-gradient(130% 150% at 100% 0%, rgba(212, 169, 78, 0.14), transparent 55%),\n                #ffffff;\n            padding: 22px 20px;\n        }\n\n        body:not(.light_theme) .blog_aside_cta_inner {\n            background:\n                radial-gradient(130% 150% at 100% 0%, rgba(212, 169, 78, 0.14), transparent 55%),\n                #101013;\n        }\n\n        .blog_aside_cta_inner h4 {\n            font-size: 15px;\n            font-weight: 700;\n            margin: 0 0 6px;\n            letter-spacing: -0.005em;\n            color: #0F172A;\n        }\n\n        body:not(.light_theme) .blog_aside_cta_inner h4 {\n            color: #f2f2f4;\n        }\n\n        .blog_aside_cta_inner p {\n            font-size: 13px;\n            line-height: 1.55;\n            color: #6B7280;\n            margin: 0 0 16px;\n        }\n\n        body:not(.light_theme) .blog_aside_cta_inner p {\n            color: #9a9aa3;\n        }\n\n        .blog_aside_cta_btn {\n            display: inline-flex;\n            align-items: center;\n            justify-content: center;\n            width: 100%;\n            height: 42px;\n            border-radius: 10px;\n            background: linear-gradient(135deg, #e8c878 0%, #c69a3f 55%, #a87f2c 100%);\n            color: #171204;\n            font-size: 13.5px;\n            font-weight: 700;\n            text-decoration: none;\n            transition: filter 0.15s, transform 0.15s;\n        }\n\n        .blog_aside_cta_btn:hover {\n            filter: brightness(1.06);\n            color: #171204;\n            text-decoration: none;\n        }\n\n        .blog_aside_toast {\n            position: fixed;\n            bottom: 28px;\n            left: 50%;\n            transform: translate(-50%, 12px);\n            background: #1c1c22;\n            border: 1px solid rgba(255, 255, 255, 0.12);\n            color: #f2f2f4;\n            font-size: 13px;\n            font-weight: 500;\n            padding: 10px 18px;\n            border-radius: 10px;\n            opacity: 0;\n            pointer-events: none;\n            z-index: 2000;\n            transition: opacity 0.25s, transform 0.25s;\n        }\n\n        .blog_aside_toast.is-show {\n            opacity: 1;\n            transform: translate(-50%, 0);\n        }\n\n        @media (min-width: 768px) {\n            .blog_detail_layout {\n                grid-template-columns: minmax(0, 1fr) minmax(220px, 280px);\n                gap: 32px 28px;\n            }\n\n            .blog_detail_sidebar {\n                align-self: start;\n            }\n\n            .blog_aside {\n                padding-left: 24px;\n                max-height: calc(100vh - 112px);\n                overflow-y: auto;\n                overscroll-behavior: contain;\n                scrollbar-width: thin;\n                padding-right: 6px;\n                gap: 26px;\n            }\n\n            body:not(.light_theme) .blog_aside {\n                border-left-color: rgba(255, 255, 255, 0.08);\n            }\n        }\n\n        @media (min-width: 992px) {\n            .blog_detail_layout {\n                grid-template-columns: minmax(0, 1fr) minmax(250px, 320px);\n                gap: 40px 48px;\n            }\n\n            .blog_aside {\n                padding-left: 28px;\n            }\n        }\n\n        @media (min-width: 1200px) {\n            .blog_detail_layout {\n                gap: 56px 72px;\n            }\n        }\n\n        @media (max-width: 767.98px) {\n            .blog_detail_page {\n                padding: 16px 0 48px;\n                overflow-x: hidden;\n            }\n\n            .blog_detail_container {\n                padding: 0 16px;\n                width: 100%;\n                max-width: 100%;\n            }\n\n            .blog_detail_page .container.blog_detail_container {\n                width: 100%;\n            }\n\n            .blog_detail_title {\n                font-size: 22px;\n                letter-spacing: -0.3px;\n                word-break: break-word;\n            }\n\n            .blog_detail_subtitle {\n                font-size: 15px;\n            }\n\n            .blog_detail_hero_img_wrap {\n                border-radius: 10px;\n                margin-bottom: 18px;\n            }\n\n            .blog-prose {\n                overflow-x: auto;\n                font-size: 14.5px;\n            }\n\n            .blog-prose h1 {\n                font-size: 22px;\n            }\n\n            .blog-prose h2 {\n                font-size: 18px;\n            }\n\n            .blog-prose h3 {\n                font-size: 16px;\n            }\n\n            .blog_takeaways_card {\n                padding: 16px;\n            }\n\n            .blog_detail_sidebar {\n                margin-top: 4px;\n            }\n\n            .blog_aside {\n                position: static;\n                max-height: none;\n                overflow: visible;\n            }\n\n            .blog_aside_sec {\n                padding: 4px 0 22px;\n            }\n\n            .blog_aside_sec+.blog_aside_sec {\n                padding-top: 22px;\n            }\n\n            .blog_aside_head {\n                flex-wrap: wrap;\n                gap: 8px;\n            }\n\n            .blog_aside_copy {\n                width: 100%;\n                justify-content: center;\n            }\n\n            .blog_aside_toc button {\n                word-break: break-word;\n            }\n\n            .blog_aside_rel {\n                align-items: flex-start;\n            }\n\n            .blog_aside_rel_thumb {\n                width: 56px;\n                height: 56px;\n                flex-shrink: 0;\n            }\n\n            .blog_aside_cta_inner {\n                padding: 18px 16px;\n            }\n\n            .blog_aside_toast {\n                left: 16px;\n                right: 16px;\n                width: auto;\n                transform: translateY(12px);\n                text-align: center;\n            }\n\n            .blog_aside_toast.is-show {\n                transform: translateY(0);\n            }\n\n            .blog_detail_author_meta,\n            .blog_detail_author_meta .author_info {\n                flex-wrap: wrap;\n            }\n\n            .blog_detail_author_meta .meta_time_date {\n                line-height: 1.4;\n            }\n        }\n\n        /* Blog List Dark Theme Overrides */\n        body:not(.light_theme) .blog-page {\n            background-color: #181a20;\n            color: #e2e8f0;\n        }\n\n        body:not(.light_theme) .blog-header h1,\n        body:not(.light_theme) .featured-post-title,\n        body:not(.light_theme) .post-card-title,\n        body:not(.light_theme) .sidebar-title,\n        body:not(.light_theme) .trending-headline {\n            color: #ffffff;\n        }\n\n        body:not(.light_theme) .blog-cat-btn {\n            background-color: #ffffff14;\n            color: #9ca3af;\n        }\n\n        body:not(.light_theme) .blog-cat-btn:hover {\n            background-color: #2a2a2a;\n        }\n\n        body:not(.light_theme) .blog-cat-btn.active {\n            background-color: #D3B06C;\n            color: #ffffff;\n        }\n\n        body:not(.light_theme) .featured-post-card,\n        body:not(.light_theme) .post-card,\n        body:not(.light_theme) .sidebar-card {\n            background: #ffffff08;\n            border-color: #222222;\n            box-shadow: 0 4px 20px rgb(0 0 0 / 6%);\n        }\n\n        body:not(.light_theme) .post-card:hover {\n            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.6);\n        }\n\n        body:not(.light_theme) .post-card-footer {\n            border-top-color: #222222;\n        }\n\n        body:not(.light_theme) .page-btn {\n            background: #ffffff12;\n            border-color: #222222;\n            color: #9ca3af;\n        }\n\n        body:not(.light_theme) .page-btn:hover:not(.active):not(:disabled) {\n            background: #1a1a1a;\n        }\n\n        body:not(.light_theme) .blog-empty {\n            color: #9ca3af;\n        }\n\n        body:not(.light_theme) .badge-tag {\n            background: rgba(211, 176, 108, 0.1);\n        }\n\n        @media (max-width: 767px) {\n\n\n            .blog_detail_title {\n                font-size: 20px;\n            }\n\n            .blog-prose ul,\n            .blog-prose ol {\n                margin: 0 0 10px 0px;\n            }\n\n            .blog-prose h1,\n            .blog-prose h2,\n            .blog-prose h3,\n            .blog-prose h4,\n            .blog-prose h5,\n            .blog-prose h6 {\n                margin-top: 12px;\n            }\n\n            .blog-page {\n                padding: 30px 0 40px 0;\n            }\n\n            .blog_detail_subtitle {\n                font-size: 14px;\n            }\n\n            .blog_section_block .section_p {\n                font-size: 14px;\n            }\n\n        }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
